export const translations = {
  sl: {
    topBar: {
      emergencyLine: 'V pripornih zadevah 24 ur dnevno na +386 41-606-346',
      emergencyPrefix: 'Nujna odvetniška pomoč 24/7 —',
      emergencyPhoneDisplay: '+386 41 606 346',
      emergencyPhoneRaw: '+38641606346',
    },
    header: {
      logo: 'Odvetniška pisarna BM odvetniki',
      home: 'Domov',
      menu: "Meni",
      practiceAreas: 'Področje dela',
      documents: 'Splošni pogoji',
      freeLegalAid: 'Brezplačna pravna pomoč',
      mediation: 'Mediacija',
      aboutUs: 'O nas',
      about: 'Kje smo',
      contact: 'Kontakt',
    },
    home: {
      title: 'Odvetniška pisarna Martina Breganta',
      titlePrefix: 'Pravna pomoč z',
      titleEmphasis: 'osebnim pristopom',
      heroLabel: 'Mengeš, Slovenija',
      ctaContact: 'Kontakt',
      ctaPracticeAreas: 'Področje dela',
      statValue: '30+',
      statLabel: 'let izkušenj',
      trustItems: [
        { value: '150+', label: 'primerov letno' },
        { value: '100%', label: 'individualen pristop' },
        { value: '24/7', label: 'nujna pomoč' },
        { value: '3', label: 'jeziki (SL, DE, EN)' },
      ],
      approachLabel: 'Naš pristop',
      approachTitle: 'Odličnost in profesionalnost',
      approachSubtitle: 'Vsak primer obravnavamo celovito in individualno.',
      approachSteps: [
        {
          title: 'Brezplačen posvet',
          text: 'V primeru prevzema vašega primera je prvi posvet brezplačen.',
        },
        {
          title: 'Individualna analiza',
          text: 'Poglobljeno preučimo vaš primer in predstavimo možne rešitve v konkretni zadevi.',
        },
        {
          title: 'Zastopanje',
          text: 'Z individualnim pristopom vas zastopamo pred sodišči in drugimi organi.',
        },
      ],
      approachQuote: '„Zaupanje strank si pridobivamo z individualnim pristopom in celovito preučitvijo vsakega primera."',
      approachQuoteCite: '— Martin Bregant, odvetnik',
      lead: 'Odvetniška pisarna BM odvetniki iz Mengša vam nudi pravno pomoč glede uveljavljanja odškodnin, izterjave terjatev, sestavljanja različnih pogodb in vas pred sodišči zastopa v civilnih, kazenskih, delovnih, gospodarskih in družinskih zadevah.\n\nPri svojem delu stremimo k odličnosti in profesionalnosti!\n\nZaupanje strank si pridobivamo z individualnim pristopom, s poglobljeno in celovito preučitvijo individualnega primera ter predstavitvijo možnih rešitev v konkretni zadevi.\n\nV odškodninskih zadevah nudimo možnost brezplačnega svetovanja.\n\nBM Odvetniki',
      emergencyBadge: 'Dosegljivi 24/7',
      emergencyTitle: 'Nujna odvetniška pomoč',
      emergencyParagraph1: 'V nujnih primerih, ko je potrebna takojšnja odvetniška pomoč – zlasti ob odvzemu prostosti, izvajanju preiskovalnih dejanj (kot sta hišna ali osebna preiskava), ogledu kraja kaznivega dejanja, odločanju o priporu ali o prisilnem zdravljenju v psihiatrični bolnišnici ter v drugih neodložljivih situacijah – smo vam na voljo 24 ur na dan, vse dni v letu.',
      emergencyParagraph2: 'Dosegljivi smo na telefonski številki +386 41 606 346.',
      emergencyParagraph3: 'Prosimo, da navedeno telefonsko številko uporabljate izključno v nujnih primerih. Za vse nenujne zadeve vas vljudno prosimo, da nas kontaktirate v času uradnih ur preko splošnih kontaktnih podatkov pisarne.',
      emergencyPhoneRaw: '+38641606346',
      emergencyPhoneDisplay: '+386 41 606 346',
      emergencyPhoneNote: 'Izključno za nujne primere',
    },
    about: {
      title: 'Kje smo',
      location: 'Lokacija',
      subtitle: 'Obiščite nas v Mengšu, v neposredni bližini Špas Teatra in Občine Mengeš.',
      cardTitle: 'Odvetniška pisarna BM',
      addressTitle: 'Naslov',
      addressLine1: 'Slovenska cesta 24',
      addressLine2: '1234 Mengeš, Slovenija',
      mapLinkLabel: 'Odpri v Google Maps ->',
      phoneTitle: 'Telefon',
      officePhone: '040-811-830 (pisarna)',
      emergencyPhone: '+386 41 606 346 (nujni primeri 24/7)',
      emailTitle: 'E-pošta',
      email: 'tajnistvo@op-bm.si',
      hoursTitle: 'Uradne ure',
      hoursText: 'Stranke sprejemamo po predhodnem dogovoru.',
      directions: [
        {
          title: 'Z avtom',
          text: 'Pisarna je v 1. nadstropju na Slovenski cesti 24. Brezplačno parkiranje (do 2 uri) je na centralnem parkirišču za stavbo.',
        },
        {
          title: 'Orientacija',
          text: 'V neposredni bližini Špas Teatra in Občine Mengeš. Vhod v pisarno je na zadnji strani stavbe, skozi notranje parkirišče pri Mestni kavarni Mesing.',
        },
        {
          title: 'Dogovor',
          text: 'Stranke sprejemamo po predhodnem dogovoru. Pokličite na 040-811-830 ali pišite na tajnistvo@op-bm.si.',
        },
      ],
      photoTitle: 'Slovenska cesta 24, Mengeš',
      photoSubtitle: '1. nadstropje · vhod na zadnji strani stavbe',
      address: 'Odvetniška pisarna se nahaja v 1. nadstropju poslovno-stanovanjske stavbe na Slovenski cesti 24 v Mengšu in sicer v neposredni bližini Špas Teatra in Občine Mengš.',
      entrance: 'Vhod v odvetniško pisarno se nahaja na zadnji strani stavbe, skozi osrednje notranje parkirnišče pri Mestni kavarni Mesing.',
      parking: 'Brezplačno parkiranje (do dve uri) za obiskovalce je na voljo na parkirnišču (centralno parkirnišče) za stavbo.',
    },
    aboutUs: {
      title: 'O nas',
      intro: 'Predstavljamo odvetniško ekipo in ključne podatke o članih naše pisarne.',
      noImage: 'Slika bo dodana naknadno',
      sectionLabel: 'O nas',
      mainTitle: 'Naša ekipa',
      teamLabel: 'Ekipa',
      teamTitle: 'Sodelavci pisarne',
      achievementsToggle: 'Dosežki in publikacije',
      yearsExperienceValue: '30+',
      yearsExperienceLabel: 'let izkušenj',
      martinHighlights: [
        { title: 'Odvetnik in mediator', text: 'Strateško zastopanje in mediacija.' },
        { title: 'Nekdanji sodnik', text: 'Izkušnje odločanja na sodišču v Ljubljani in Kamniku.' },
        { title: 'Osebni pristop', text: 'Premišljeno in odgovorno pravno zastopanje.' },
        { title: 'Po predhodnem dogovoru', text: 'Stranke sprejema po dogovoru.' },
      ],
      mojcaTags: ['Družinsko pravo', 'Delovno pravo', 'Kazensko pravo', 'SL / EN / HR / SR / DE'],
      thirdTags: ['Organizacija pisarne', 'Administracija', 'SL / EN'],
      martin: {
        role: 'Martin Bregant, odvetnik, mediator in direktor',
        paragraphs: [
          'Martin Bregant je leta 2025 obeležil 30 let samostojnega opravljanja odvetniškega poklica. Svojo poklicno pot je začel kot sodnik na Okrajnem sodišču v Ljubljani ter kasneje še na Okrajnem sodišču v Kamniku. Leta 1995 je sodniško kariero zaključil in svojo strokovno pot nadaljeval kot odvetnik.',
          'Svojim strankam nudi premišljeno, strateško in odgovorno pravno zastopanje. Izhaja iz temeljite pravne presoje primera, ob upoštevanju sodne prakse, dokaznih možnosti in realnih procesnih tveganj. Zaradi dolgoletnih izkušenj v sodstvu in odvetništvu zna oceniti zadevo tudi z vidika odločanja sodišča, kar omogoča premišljeno načrtovanje strategije.',
          'Zaveda se, da pravni postopki za posameznika predstavljajo pomembno življenjsko prelomnico, zato si prizadeva za strokovno, a hkrati človeško obravnavo vsake zadeve.',
          'Poleg odvetniškega dela deluje tudi kot mediator. Stranke ga lahko najamejo za vodenje mediacijskih postopkov, kadar želijo spor rešiti mirno, hitro in z dogovorom, ki upošteva interese vseh udeleženih. Njegove izkušnje iz sodstva in odvetništva mu omogočajo nepristransko in učinkovito vodenje mediacijskega procesa.',
          'Stranke sprejema po predhodnem dogovoru.',
        ],
        contactTitle: 'Kontakt:',
        emailLabel: 'e-pošta:',
        phoneLabel: 'Telefon:',
        email: 'martin.bregant@siol.net',
        phone: '040-811-830',
      },
      mojca: {
        role: 'Mojca Musič, mag. prava, odvetniška pripravnica in sodniška pripravnica',
        paragraphs: [
          'Mojca Musič je v pisarni zaposlena kot odvetniška pripravnica, ki hkrati opravlja tudi sodniško pripravništvo pri Okrožnem sodišču v Ljubljani.',
          'Leta 2024 je pod vodstvom izr. prof., mag. can. ius., dr. Borut Holcman, univ. dipl. theol., moralno juridični spec. z odliko magistrirala na Pravni fakulteti Univerze v Mariboru, iz področja zgodovine odvetništva. Trenutno je doktorska kandidatka na področju pravne zgodovine, kjer nadaljuje raziskovanje vloge odvetništva v pravnem procesu.',
          'Pri svojem delu se največ ukvarja z družinskim, delovnim in kazenskim pravom, pri čemer posebno strokovno in osebno predanost namenja področju družinskega prava. Verjame, da gre za pravno področje, ki posega neposredno v dostojanstvo, varnost in temeljne življenjske okoliščine posameznika. Ima izrazit občutek za sočloveka.',
          'Pri delu aktivno uporablja slovenski, angleški, hrvaški in srbski jezik, pogovorno pa tudi nemški jezik.',
          'Stranke sprejema po predhodnem dogovoru.',
        ],
        contactTitle: 'Kontakt:',
        emailLabel: 'e-pošta:',
        phoneLabel: 'telefon:',
        email: 'mojca.remic@op-bm.si',
        phone: '040-811-830',
        achievementsTitle: 'DOSEŽKI:',
        achievements: [
          '2017 – 1. mesto na literarnem natečaju Društva študentov PF UM z esejem »Sodbe sodišč Republike Slovenije pred Evropskim sodiščem za človekove pravice (ESČP)« in objava članka v reviji Iusto Iure',
          '2019 – 1. mesto na tekmovanju iz mediacije (področje delovnega prava), organiziranem s strani Pravne fakultete Univerze v Mariboru',
          '2020 - sodelovanje na projektu “ŠIPK – Meritve karakteristik elektromotorja za pogon električnega vozila” na Fakulteti za energetiko Univerze v Mariboru, kjer je bila osredotočena na preverjanje skladnosti proizvodov z nacionalnimi in evropskimi predpisi ter pripravo tehnične dokumentacije.',
          '2020 - Udeležba na konferenci “What are human rights?”, organizator: United for Human Rights (UHR)',
          '2021 – sodelovanje pri projektu Amicus Curiae (praksa na Upravnem sodišču Republike Slovenije in Okrožnem sodišču v Mariboru)',
          '2026 - Delovni vodja projekta “Konstitutivni poklici v pravosodju”, ki poteka na podlagi javnega razpisa »Problemsko učenje študentov v delovno okolje: gospodarstvo, negospodarstvo in neprofitni sektor v lokalnem/regionalnem okolju 2024-2027 (PUŠ v delovno okolje 2024-2027) - 2. odpiranje«.',
        ],
        bibliographyTitle: 'OSEBNA BIBLIOGRAFIJA:',
        bibliography: [
          'REMIC, Mojca. Ali delavec lahko odkloni službeno pot, ker ne želi opraviti obveznega cepljenja?. Pravna praksa : PP. [Tiskana izd.]. 29. avg. 2024, leto 42, št. 30/31, str. 20-21, avtorj. sl. ISSN 0352-0730. [COBISS.SI-ID 205701891]',
          'REMIC, Mojca. "Beschirmern vor vnrecht" - vloga odvetnika v procesu skozi zgodovino : magistrsko delo. Maribor: [M. Remic], 2024. 1 spletni vir (1 datoteka PDF (76 str.)). Digitalna knjižnica Univerze v Mariboru – DKUM. [COBISS.SI-ID 199769859]',
          'REMIC, Mojca. Pot k digitalizaciji pravosodja v EU : uredba (EU) 2020/1784 o vročanju sodnih in izvednsodnih pisanj v civilnih ali gospodarskih zadevah. Pravna praksa : PP. [Tiskana izd.]. 10. okt. 2024, leto 43, št. 37/38, str. 7-8, avtorj. sl. ISSN 0352-0730. [COBISS.SI-ID 211008771]',
          'REMIC, Mojca. Pogodba o dosmrtnem preživljanju med zakoncema. Pravna praksa : PP. [Tiskana izd.]. 6. mar. 2025, leto 44, št. 9, str. 9-10, z avtorj. sl. ISSN 0352-0730. [COBISS.SI-ID 228136707]',
        ],
      },
      third: {
        role: 'Maša Rožman, dipl. prav., Vodja pisarne',
        paragraphs: [
          'Maša Rožman je zaposlena kot vodja odvetniške pisarne.',
          'Svoje delo opravlja strokovno, odgovorno in z izrazitim občutkom za potrebe strank. Kot vodja pisarne opravlja vsa organizacijska in administrativna dela ter skrbi, da delo v pisarni poteka tekoče in nemoteno.',
          'Leta 2023 je z odliko diplomirala na Pravni fakulteti Univerze v Mariboru, kjer trenutno zaključuje magistrski študij.',
          'Odlikujejo jo natančnost, strateško razmišljanje ter osebni pristop, s katerim gradi dolgoročne in zaupanja vredne odnose.',
          'Pri svojem delu aktivno uporablja slovenski in angleški jezik.',
        ],
        contactTitle: 'Kontakt:',
        emailLabel: 'e-pošta:',
        phoneLabel: 'telefon:',
        email: 'tajnistvo@op-bm.si',
        phone: '040-811-830',
      },
    },
    contact: {
      title: 'Kontakt',
      intro: 'Za pravno svetovanje nas kontaktirajte: ',
      email: 'info@novak-partnerji.si',
      phone: '+386 1 234 5678',
      workingHours: {
        title: 'Delovni čas',
        hours: 'Pisarna je odprta vsak dan od ponedeljka do petka in sicer od 8:00 ure do 16:00 ure, razen ob petkih do 13:00 ure.',
        reservation: 'Za sestanek v pisarni je obvezna predhodna rezervacija termina po telefonu ali preko kontaktnega obrazca.',
        response: 'Na vaše vprašanje vam bomo odgovorili v najkrajšem možnem času.',
        documents: 'Na dogovorjen termin s seboj prinesete vso razpoložljivo dokumentacijo v zvezi z vašo zadevo. Po zaključku sestanka vam bodo predstavljeni okvirni stroški vašega primera, nato pa boste, če se boste odločili za naše zastopanje, podpisali pooblastilo, na podlagi katerega bomo lahko takoj pričeli z delom.',
      },
      form: {
        name: 'Ime in priimek',
        namePlaceholder: 'Vaše ime in priimek',
        email: 'E-pošta',
        emailPlaceholder: 'vaš@email.example',
        subject: 'Zadeva',
        subjectPlaceholder: 'Kratek povzetek povpraševanja',
        message: 'Sporočilo',
        messagePlaceholder: 'Podrobnosti vašega vprašanja',
        submit: 'Pošlji',
      },
      status: {
        required: 'Izpolnite vsa polja.',
        invalidEmail: 'Vnesite veljaven e-poštni naslov.',
        sending: 'Pošiljanje sporočila ...',
        success: 'Sporočilo je bilo uspešno poslano.',
        error: 'Napaka pri pošiljanju. Poskusite znova.',
        botDetected: 'Pošiljanje ni uspelo.',
      },
    },
    practiceAreas: {
      title: 'Področje dela',
      intro: 'Naša odvetniška pisarna pokriva širok spekter pravnih področij.',
      areas: [
        {
          title: 'GOSPODARSKO POGODBENO PRAVO IN POSLOVNA RAZMERJA',
          points: [
            'svetujemo pri vprašanjih, povezanih z domačimi in mednarodnimi poslovnimi razmerji',
            'sestavljamo in pregledujemo gospodarske pogodbe',
            'sodelujemo pri pogajanjih',
            'zastopamo v sodnih sporih, ki izvirajo iz pogodbenih in poslovnih razmerij',
            'pripravljamo skrbne preglede poslovanja',
          ]
        },
        {
          title: 'GOSPODARSKI SPORI IN IZTERJAVA',
          points: [
            'zastopamo v vseh gospodarskih sporih in na mediaciji',
            'svetujemo pri urejanju upniško – dolžniških razmerij',
            'zastopamo v izvršilnih postopkih',
          ]
        },
        {
          title: 'STEČAJNO IN INSOLVENČNO PRAVO',
          points: [
            'svetujemo v stečajnih postopkih ter postopkih prisilne poravnave in likvidacije',
            'prijavljamo terjatve, ločitvene pravice in izločitvene pravice upnikov v postopku stečaja in prisilne poravnave',
            'zastopamo v drugih postopkih, ki so povezani s stečajnimi postopki in postopki prisilne poravnave',
          ]
        },
        {
          title: 'GOSPODARSKO KAZENSKO PRAVO',
          points: [
            'sestavljamo kazenske ovadbe',
            'sestavljamo in vlagamo zasebne tožbe',
            'sestavljamo premoženjsko pravne zahtevke oškodovancev s kaznivimi dejanji',
          ]
        },
        {
          title: 'NEPREMIČNINSKO PRAVO',
          points: [
            'svetujemo, sestavljamo ali pregledujemo vse vrste pogodb, povezanih z nepremičninami',
            'sodelujemo pri ustanavljanju služnostnih in drugih pravic',
            'zastopamo v sporih v zvezi z nepremičninami ter pravicami, povezanimi z nepremičninami in najemnimi razmerji',
            'zastopamo v posestnih sporih in nepravdnih postopkih ureditve meje, razdružitve solastnine, določitve nujne poti',
            'svetujemo pri urejanju stanovanjskih razmerij in najemnih razmerij',
            'pripravljamo akte etažne lastnine',
            'predlagamo vpise v zemljiško knjigo',
          ]
        },
        {
          title: 'OBLIGACIJSKA RAZMERJA',
          points: [
            'svetujemo in zastopamo pri odškodninskih sporih',
            'sestavljamo pogodbe obligacijskega prava',
            'svetujemo in zastopamo pri obligacijskopravnih sporih',
          ]
        },
        {
          title: 'DEDNO PRAVO',
          points: [
            'svetujemo in zastopamo pri dednopravnih vprašanjih, zapuščinskih postopkih in dednih sporih',
            'sestavljamo oporoke',
            'sestavljamo izročilne pogodbe, preužitkarske pogodbe in pogodbe o dosmrtnem preživljanju',
          ]
        },
        {
          title: 'DRUŽINSKO PRAVO',
          points: [
            'svetujemo glede pravnih vprašanj razveze zakonske zveze in razhoda zunajzakonskih partnerjev, delitve premoženja in določanja preživnine',
            'zastopamo v razveznih pravdah in postopkih delitve premoženja',
          ]
        },
        {
          title: 'DELOVNO PRAVO',
          points: [
            'svetujemo v delovnopravnih zadevah',
            'pripravljamo interne splošne delovne akte delodajalca',
            'svetujemo in zastopamo v postopkih odpovedi pogodb o zaposlitvi',
            'zastopamo v ostalih delovnopravnih sporih',
            'sodelujemo pri izvedbi disciplinskih postopkov',
          ]
        },
        {
          title: 'UPRAVNI POSTOPKI IN UPRAVNI SPORI',
          points: [
            'svetujemo in sodelujemo pri inšpekcijskih postopkih',
            'sestavljamo in vlagamo tožbe v upravnih sporih',
          ]
        },
      ]
    },
    documents: {
      title: 'Splošni pogoji',
      intro: 'Odvetnik Martin Bregant (v nadaljevanju: odvetnik) je član Odvetniške zbornice Slovenije in je upravičen do obračunavanja odvetniških storitev skladno z vsakokrat veljavno Odvetniško tarifo Odvetniške zbornice Slovenije (v nadaljevanju: Odvetniška tarifa), razen če je s stranko sklenjen drugačen pisni dogovor.',
      sections: [
        {
          title: 'Nastanek mandatnega razmerja',
          paragraphs: [
            'Odvetnik ni zavezan sprejeti vsakega ponujenega pooblastila. Mandatno razmerje nastane, ko odvetnik izrecno potrdi sprejem pooblastila ali stranki kako drugače pisno potrdi, da je prevzel zastopanje oziroma začel opravljati pravne storitve.',
            'V primeru dvoma se šteje, da je mandat sprejet z dnem pisne potrditve ali z dnem, ko odvetnik dejansko začne opravljati naročene storitve ob vednosti in soglasju stranke.',
          ],
        },
        {
          title: 'Način obračunavanja storitev',
          paragraphs: [],
        },
        {
          title: '1. Uporaba Odvetniške tarife',
          paragraphs: [
            'Če med odvetnikom in stranko ni sklenjen poseben dogovor o drugačnem načinu obračuna, se storitve obračunavajo skladno z določbami Odvetniške tarife.',
          ],
        },
        {
          title: '2. Dogovor o drugačnem plačilu',
          paragraphs: [
            'Odvetnik in stranka lahko skladno z veljavnimi predpisi skleneta pisni dogovor o drugačnem načinu plačila (v nadaljevanju: poseben dogovor).',
            'Če odvetnik stranki predlaga urno postavko in stranka s tem soglaša (izrecno ali konkludentno, tako da dopusti začetek dela brez ugovora), se šteje, da je sklenjen poseben dogovor o obračunu po urni postavki. Urna postavka je stranki vedno potrjena v pisni obliki (npr. po elektronski pošti). Ti splošni pogoji so sestavni del takšnega dogovora, razen če je izrecno dogovorjeno drugače.',
            'Če je dogovorjen pavšalni znesek, se storitve, ki presegajo dogovorjeni obseg, obračunajo po dogovorjeni urni postavki ali - če ta ni določena - po Odvetniški tarifi.',
            'V kolikor posamezna storitev ni zajeta v posebnem dogovoru, se zanjo uporablja Odvetniška tarifa.',
          ],
        },
        {
          title: 'Urna postavka in stroški',
          paragraphs: [
            'Odvetnik lahko letno oblikuje informativni cenik, pri čemer upošteva inflacijo, zahtevnost storitev ter druge relevantne okoliščine.',
            'Glede na naravo in kompleksnost posamezne zadeve lahko odvetnik predlaga standardno ali višjo urno postavko. Končna višina je predmet dogovora s stranko.',
            'Najmanjša obračunska enota pri urni postavki znaša 30 minut.',
            'Poleg nagrade si odvetnik pridržuje pravico obračunati materialne stroške v višini 3 % vrednosti storitve, razen če je dogovorjeno drugače.',
            'Če ni drugače določeno, se poštne pošiljke obračunajo pavšalno oziroma po dejanskih stroških, kadar ti odstopajo od navedenih zneskov:',
          ],
          bullets: [
            '5 EUR za priporočeno pošiljko v Sloveniji',
            '10 EUR za pošiljko znotraj EU',
            '20 EUR za pošiljko izven EU',
          ],
        },
        {
          title: 'Izdaja računov in plačilni pogoji',
          paragraphs: [
            'Če ni dogovorjeno drugače, odvetnik izstavlja račune mesečno za opravljeno delo v preteklem obdobju ali po zaključku posamezne smiselno zaključene faze postopka.',
            'Rok plačila znaša 8 dni od izdaje računa, razen če je dogovorjeno drugače.',
            'V primeru zamude je stranka dolžna plačati zakonske zamudne obresti ter morebitne stroške izterjave.',
            'Če odvetnik postane zavezanec za DDV, se na vse storitve obračuna DDV skladno z veljavno zakonodajo.',
            'Odvetnik lahko po lastni presoji zniža obračunano nagrado, ne more pa je enostransko zvišati mimo dogovora.',
            'Odvetnik je upravičen, da od zneskov, ki jih prejme za račun stranke, poravna zapadle terjatve iz naslova svojih storitev ter o tem izda ustrezen račun z označbo plačila, preostanek pa nakaže stranki.',
          ],
        },
        {
          title: 'Opozorilo glede povračila stroškov v postopkih',
          paragraphs: [
            'Sodišča in drugi organi priznavajo in odmerjajo stroške zastopanja praviloma v višini, določeni po Odvetniški tarifi, ne glede na morebitni drugačen dogovor med odvetnikom in stranko.',
          ],
        },
        {
          title: 'Preklic pooblastila',
          paragraphs: [
            'Če stranka brez utemeljenega razloga prekliče pooblastilo pred zaključkom zadeve, je dolžna poravnati vrednost že opravljenih storitev in nastalih stroškov do dneva preklica, razen če je izrecno dogovorjeno drugače.',
            'Za morebitne spore je krajevno pristojno sodišče po sedežu odvetnika.',
          ],
        },
        {
          title: 'Zaupnost in varstvo osebnih podatkov',
          paragraphs: [
            'Vse informacije in dokumenti, ki si jih izmenjata odvetnik in stranka, se obravnavajo kot zaupni.',
            'Odvetnik lahko zaradi preverjanja morebitnega konflikta interesov razkrije obstoj mandatnega razmerja in splošno naravo zadeve, ne pa vsebine zaupnih podatkov.',
            'Pri opravljanju storitev lahko pride do obdelave osebnih podatkov skladno z veljavno evropsko in nacionalno zakonodajo. Odvetnik osebne podatke uporablja izključno za namen izvajanja pravnih storitev, jih varuje kot zaupne in zagotavlja ustrezne varnostne ukrepe.',
            'Po prenehanju mandatnega razmerja se osebni podatki vrnejo ali uničijo, kadar je to dopustno in skladno z zakonodajo.',
          ],
        },
        {
          title: 'Omejitev odgovornosti',
          paragraphs: [
            'Odškodninska odgovornost odvetnika je omejena na znesek plačanih honorarjev za storitve, opravljene v 30 dneh pred dogodkom, iz katerega izhaja morebitna odgovornost.',
            'Odvetnik ne odgovarja za posredno škodo, izgubljeni dobiček, izpad prihodkov ali druge posledične škode.',
            'Odvetnik ima sklenjeno obvezno zavarovanje poklicne odgovornosti pri zavarovalnici Wiener Städtische v okviru zavarovalne sheme Odvetniške zbornice Slovenije.',
          ],
        },
      ],
    },
    freeLegalAid: {
      title: 'Brezplačna pravna pomoč',
      paragraphs: [
        'V odvetniški pisarni nudimo tudi zastopanje strank tudi v okviru brezplačne pravne pomoči (BPP).',
        'Z brezplačno pravno pomočjo se uresničuje pravica do sodnega varstva za osebe, ki brez škode za svoje preživljanje in preživljanje svoje družine te pravice ne bi mogle uresničevati. Upravičencem, ki izpolnjujejo finančne in vsebinske pogoje, omogoča v prvi vrsti sodno varstvo, izjemoma tudi predsodno svetovanje in sklenitev poravnav.',
        'Preden odvetnik začne delo, potrebuje odločbo o brezplačni pravni pomoči in napotnico za brezplačno pravno pomoč, ki ju na sodišču izda Strokovna služba za brezplačno pravno pomoč.',
        'Strankam nudimo pomoč tudi pri izpolnitvi in pripravi vloge za dodelitev brezplačne pravne pomoči (BPP), vključno s pregledom potrebne dokumentacije in svetovanjem glede izpolnjevanja finančnih pogojev.',
      ],
      linksTitle: 'Vlogo je mogoče oddati elektronsko preko portala e-Uprava ali pisno pri pristojnem sodišču:',
      links: [
        {
          label: 'https://e-uprava.gov.si/podrocja/vloge/vloga.html?id=1225',
          url: 'https://e-uprava.gov.si/podrocja/vloge/vloga.html?id=1225',
        },
        {
          label: 'https://e-uprava.gov.si/si/podrocja/drzava-druzba/pravna-pomoc/brezplacna-pravna-pomoc',
          url: 'https://e-uprava.gov.si/si/podrocja/drzava-druzba/pravna-pomoc/brezplacna-pravna-pomoc',
        },
      ],
    },
    mediation: {
      title: 'Mediacija',
      paragraphs: [
        'V odvetniški pisarni veliko pozornosti posvečamo alternativnemu reševanju sporov, da bi se stranke izognile sodnemu reševanju.',
        'Mediacija je zaupen in strukturiran postopek mirnega reševanja sporov, pri katerem nevtralna tretja oseba - mediator - pomaga strankam doseči sporazumno rešitev. Njena bistvena prednost je, da stranki sami oblikujeta rešitev, ki upošteva njune interese, potrebe in prihodnje odnose, namesto da o sporu odloči sodišče.',
        'Odvetnik Martin Bregant je tudi izkušen in učinkovit mediator, ki ga je mogoče angažirati za reševanje tako sodnih kot izvensodnih sporov. Kot mediator deluje nepristransko in skrbi za uravnotežen, konstruktiven dialog med strankama.',
        'Postopek mediacije je praviloma hitrejši in stroškovno ugodnejši od sodnega postopka, hkrati pa omogoča večjo fleksibilnost in zaupnost. Dosežen dogovor je lahko podlaga za sodno poravnavo ali izvršljiv sporazum, če se stranki tako odločita.',
        'Če razmišljate o mediaciji kot načinu reševanja spora, vam z veseljem svetujemo glede primernosti postopka in možnosti njegove izvedbe.',
      ],
      bulletsTitle: 'Mediacija je posebej smiselna:',
      bullets: [
        'kadar želita stranki ohraniti korekten ali trajen odnos (npr. v družinskih, partnerskih ali poslovnih razmerjih)',
        'kadar je pomembna hitra in diskretna rešitev spora',
        'kadar želita stranki aktivno sodelovati pri oblikovanju dogovora',
        'kadar obstaja možnost sporazuma, a je komunikacija med strankama otežena',
      ],
      contactTitle: 'Kontakt',
      emailLabel: 'E-pošta:',
      email: 'tajnistvo@op-bm.si',
      phoneLabel: 'Telefon:',
      phone: '040-811-830',
      linksTitle: 'Več o postopku mediacije:',
      links: [
        {
          label: 'https://www.odv-zb.si/mediacijski-center/pogosta-vprasanja-in-odgovori/#htoc-v-katerih-primerih-je-mediacija-smiselna',
          url: 'https://www.odv-zb.si/mediacijski-center/pogosta-vprasanja-in-odgovori/#htoc-v-katerih-primerih-je-mediacija-smiselna',
        },
        {
          label: 'https://nasodiscu.si/mediacija',
          url: 'https://nasodiscu.si/mediacija',
        },
      ],
    },
    privacy: {
      title: "Politika zasebnosti",
      intro: "Ta politika pojasnjuje, katere osebne podatke obdelujemo prek te spletne strani, s kakšnim namenom in na kateri pravni podlagi, komu jih posredujemo ter kakšne pravice imate v zvezi z njimi.",
      updated: "Zadnja sprememba: 14. 10. 2026",
      sections: [
        {
          title: "1. Upravljavec osebnih podatkov",
          paragraphs: [
            "Upravljavec osebnih podatkov, ki se obdelujejo prek te spletne strani, je Odvetniška pisarna Martina Breganta, Slovenska cesta 24, 1234 Mengeš, Slovenija.",
            "Matična številka: 2511975000. Davčna številka: 10045503.",
            "Glede varstva osebnih podatkov smo dosegljivi na elektronskem naslovu tajnistvo@op-bm.si in na telefonski številki 040 811 830.",
          ],
        },
        {
          title: "2. Kateri osebni podatki se obdelujejo",
          paragraphs: [
            "Spletna stran ne zahteva registracije in ne ustvarja uporabniških računov. Osebne podatke obdelamo samo takrat, ko nam jih sami posredujete:",
          ],
          bullets: [
            "Kontaktni obrazec: ime, elektronski naslov, zadeva in vsebina sporočila.",
            "Neposredni stik: podatki, ki nam jih posredujete, če nas pokličete ali nam pišete na naslov, objavljen na tej strani.",
            "Tehnični podatki: ob obisku se vzpostavijo povezave do zunanjih storitev, opisanih v 5. točki, ki prejmejo vaš IP naslov.",
          ],
          extra: [
            "Spletna stran nima vgrajene analitike, števcev obiska, oglaševalskih sledilnikov ali profiliranja. Na podlagi vaših podatkov ne sprejemamo avtomatiziranih odločitev.",
          ],
        },
        {
          title: "3. Namen in pravna podlaga obdelave",
          bullets: [
            "Odgovor na vaše povpraševanje in morebitna sklenitev pogodbenega razmerja — pravna podlaga je izvajanje ukrepov pred sklenitvijo pogodbe na vašo zahtevo (člen 6(1)(b) Splošne uredbe o varstvu podatkov).",
            "Delovanje, varnost in zaščita spletne strani pred zlorabami — pravna podlaga je naš zakoniti interes (člen 6(1)(f) Splošne uredbe).",
            "Izpolnjevanje zakonskih obveznosti, ki veljajo za odvetniški poklic — pravna podlaga je zakonska obveznost (člen 6(1)(c) Splošne uredbe).",
          ],
          paragraphs: [
            "Posredovanje podatkov prek kontaktnega obrazca ni zakonska ali pogodbena obveznost. Če podatkov ne posredujete, na vaše sporočilo preprosto ne moremo odgovoriti.",
          ],
        },
        {
          title: "4. Kontaktni obrazec",
          paragraphs: [
            "Ko oddate kontaktni obrazec, se vpisani podatki iz vašega brskalnika pošljejo prek storitve za pošiljanje elektronske pošte iz spletnih obrazcev (EmailJS), ki opravi dostavo v elektronski predal pisarne. Ponudnik te storitve v tem obsegu nastopa kot obdelovalec osebnih podatkov.",
            "Obrazec vsebuje skrito polje za preprečevanje neželene pošte, ki ga obiskovalec ne izpolnjuje; izpolnjeno polje pomeni samodejno oddajo in sporočilo se ne pošlje. V tem polju se ne obdelujejo osebni podatki.",
            "Vaše sporočilo prejmemo v elektronski predal pisarne in ga obravnavamo zaupno, skladno z dolžnostjo varovanja odvetniške tajnosti.",
            "Prek kontaktnega obrazca ne pošiljajte občutljivih osebnih podatkov ali podrobnosti svoje zadeve. Za to se raje dogovorite za osebni ali telefonski razgovor.",
          ],
        },
        {
          title: "5. Zunanje storitve, vgrajene v spletno stran",
          paragraphs: [
            "Spletna stran uporablja dve storitvi družbe Google, ki se naložita neposredno z Googlovih strežnikov. Ob tem se Googlu razkrije vaš IP naslov in osnovni podatki o vašem brskalniku, in sicer še preden karkoli kliknete. Na obseg te obdelave nimamo vpliva.",
          ],
          bullets: [
            "Google Fonts: pisave se naložijo s strežnikov fonts.googleapis.com in fonts.gstatic.com. To se zgodi na vsaki podstrani.",
            "Google Zemljevidi: na podstrani »Kje smo« je vgrajen zemljevid z lokacijo pisarne. Ob odprtju te podstrani se vzpostavi povezava s strežniki Google, ki lahko v vašem brskalniku nastavijo piškotke.",
          ],
          extra: [
            "Googlova politika zasebnosti je dostopna na naslovu https://policies.google.com/privacy. Če teh povezav ne želite vzpostaviti, lahko uporabite brskalnik ali razširitev, ki blokira zahteve do Googlovih domen; spletna stran bo delovala tudi brez njih, le s sistemsko pisavo in brez prikaza zemljevida.",
          ],
        },
        {
          title: "6. Piškotki in lokalna shramba",
          paragraphs: [
            "Ta spletna stran sama ne nastavlja piškotkov in ne uporablja piškotkov za analitiko ali oglaševanje.",
            "V lokalno shrambo vašega brskalnika se shrani en sam podatek — izbrani jezik vmesnika (slovenščina, nemščina ali angleščina) — da vam ga ob naslednjem obisku ni treba izbirati znova. Ta podatek ostane v vašem brskalniku, se ne pošilja na strežnik in ne omogoča vaše identifikacije. Izbrišete ga lahko kadar koli z brisanjem podatkov brskalnika.",
            "Piškotke lahko nastavi Google ob prikazu vgrajenega zemljevida, kot je opisano v 5. točki.",
          ],
        },
        {
          title: "7. Hramba podatkov",
          paragraphs: [
            "Sporočila, prejeta prek kontaktnega obrazca, hranimo 12 mesecev od zadnje komunikacije, nato jih izbrišemo.",
            "Če na podlagi vašega povpraševanja pride do sklenitve pogodbenega razmerja, se podatki hranijo v okviru spisa zadeve skladno z roki, ki jih določata zakonodaja in pravila odvetniškega poklica.",
          ],
        },
        {
          title: "8. Uporabniki podatkov in prenos v tretje države",
          paragraphs: [
            "Osebnih podatkov ne prodajamo in jih ne posredujemo tretjim osebam za njihove lastne namene.",
          ],
          bullets: [
            "Ponudnik storitve pošiljanja e-pošte iz spletnih obrazcev (obdelovalec).",
            "Ponudnik elektronske pošte, v katerega predal prispe vaše sporočilo (obdelovalec).",
            "Ponudnik gostovanja spletne strani: Netlify (Netlify, Inc., ZDA).",
            "Google — v obsegu, opisanem v 5. točki.",
            "Pristojni organi, kadar nam to nalaga zakon.",
          ],
          extra: [
            "Nekateri od navedenih ponudnikov lahko podatke obdelujejo tudi zunaj Evropskega gospodarskega prostora. V takem primeru prenos poteka na podlagi mehanizmov, ki jih predvideva Splošna uredba o varstvu podatkov — standardnih pogodbenih določil ali sklepa Evropske komisije o ustreznosti ravni varstva podatkov.",
          ],
        },
        {
          title: "9. Vaše pravice",
          paragraphs: [
            "V zvezi s svojimi osebnimi podatki imate pravico:",
          ],
          bullets: [
            "do dostopa do podatkov, ki jih obdelujemo o vas;",
            "do popravka netočnih ali dopolnitve nepopolnih podatkov;",
            "do izbrisa podatkov, kadar za obdelavo ni več podlage;",
            "do omejitve obdelave;",
            "do prenosljivosti podatkov, ki ste nam jih posredovali;",
            "do ugovora obdelavi, ki temelji na našem zakonitem interesu;",
            "do preklica privolitve, kadar obdelava temelji nanjo, pri čemer preklic ne vpliva na zakonitost obdelave pred preklicem.",
          ],
          extra: [
            "Pravico uveljavite s sporočilom na tajnistvo@op-bm.si. Odgovorimo vam najkasneje v enem mesecu od prejema zahteve.",
            "Če menite, da obdelava vaših osebnih podatkov krši predpise, imate pravico vložiti pritožbo pri nadzornem organu — Informacijskem pooblaščencu Republike Slovenije.",
            "Upoštevajte, da je dostop do podatkov, ki so zajeti z odvetniško tajnostjo, lahko omejen skladno s predpisi, ki urejajo odvetništvo.",
          ],
        },
        {
          title: "10. Varnost podatkov",
          paragraphs: [
            "Spletna stran je dostopna prek šifrirane povezave HTTPS. Dostop do prejete elektronske pošte je omejen na osebe v pisarni, ki morajo zadevo obravnavati, in je zavezan odvetniški tajnosti.",
            "Noben prenos podatkov prek interneta ni popolnoma varen, zato vam za posredovanje občutljivih podatkov priporočamo osebni razgovor.",
          ],
        },
        {
          title: "11. Spremembe politike zasebnosti",
          paragraphs: [
            "Politiko lahko spremenimo, kadar se spremeni delovanje spletne strani ali veljavni predpisi. Veljavna je različica, objavljena na tej podstrani; datum zadnje spremembe je naveden na vrhu.",
          ],
        },
      ],
    },
    footer: {
      privacy: "Politika zasebnosti",
      contact: 'Kontakt',
      location: 'Kje smo',
      accounts: 'Transakcijski račun',
      credit: '© %year% Odvetniška pisarna BM odvetniki',
    },
  },
  de: {
    topBar: {
      emergencyLine: 'In Haftsachen 24 Stunden täglich unter +386 41-606-346',
      emergencyPrefix: 'Dringende anwaltliche Hilfe 24/7 —',
      emergencyPhoneDisplay: '+386 41 606 346',
      emergencyPhoneRaw: '+38641606346',
    },
    header: {
      logo: 'BM Anwälte',
      home: 'Startseite',
      menu: "Menü",
      practiceAreas: 'Tätigkeitsbereiche',
      documents: 'Allgemeine Bedingungen',
      freeLegalAid: 'Kostenlose Rechtshilfe',
      mediation: 'Mediation',
      aboutUs: 'Über uns',
      about: 'Wo wir sind',
      contact: 'Kontakt',
    },
    home: {
      title: 'Anwaltskanzlei Martin Bregant',
      titlePrefix: 'Rechtshilfe mit',
      titleEmphasis: 'individuellem Ansatz',
      heroLabel: 'Mengeš, Slowenien',
      ctaContact: 'Kontakt',
      ctaPracticeAreas: 'Tätigkeitsbereiche',
      statValue: '30+',
      statLabel: 'Jahre Erfahrung',
      trustItems: [
        { value: '150+', label: 'Fälle pro Jahr' },
        { value: '100%', label: 'individueller Ansatz' },
        { value: '24/7', label: 'Notfallhilfe' },
        { value: '3', label: 'Sprachen (SL, DE, EN)' },
      ],
      approachLabel: 'Unser Ansatz',
      approachTitle: 'Exzellenz und Professionalität',
      approachSubtitle: 'Jeden Fall behandeln wir umfassend und individuell.',
      approachSteps: [
        {
          title: 'Kostenlose Erstberatung',
          text: 'Wenn wir Ihren Fall übernehmen, ist das erste Beratungsgespräch kostenlos.',
        },
        {
          title: 'Individuelle Analyse',
          text: 'Wir prüfen Ihren Fall eingehend und präsentieren mögliche Lösungen für die konkrete Angelegenheit.',
        },
        {
          title: 'Vertretung',
          text: 'Mit einem individuellen Ansatz vertreten wir Sie vor Gerichten und anderen Behörden.',
        },
      ],
      approachQuote: '„Das Vertrauen unserer Mandanten gewinnen wir durch einen individuellen Ansatz und eine umfassende Prüfung jedes einzelnen Falls.“',
      approachQuoteCite: '— Martin Bregant, Rechtsanwalt',
      lead: 'Die Anwaltskanzlei BM Anwälte aus Mengeš bietet Ihnen rechtliche Hilfe bei der Geltendmachung von Schadensersatz, der Beitreibung von Forderungen, der Erstellung verschiedener Verträge und vertritt Sie vor Gericht in Zivil-, Straf-, Arbeits-, Handels- und Familienangelegenheiten.\n\nIn unserer Arbeit streben wir nach Exzellenz und Professionalität!\n\nDas Vertrauen unserer Mandanten gewinnen wir durch einen individuellen Ansatz, eine gründliche und umfassende Untersuchung des Einzelfalls sowie die Darstellung möglicher Lösungen in der konkreten Angelegenheit.\n\nIn Schadensersatzsachen bieten wir kostenlose Rechtsbera­tung an.\n\nBM Anwälte',
      emergencyBadge: '24/7 erreichbar',
      emergencyTitle: 'Dringende anwaltliche Hilfe',
      emergencyParagraph1: 'In dringenden Fällen, in denen sofortige anwaltliche Hilfe erforderlich ist – insbesondere bei Freiheitsentzug, Durchführung von Ermittlungsmaßnahmen (wie Haus- oder Personendurchsuchung), Tatortbesichtigung, Entscheidungen über Untersuchungshaft oder über eine zwangsweise Behandlung in einer psychiatrischen Klinik sowie in anderen unaufschiebbaren Situationen – stehen wir Ihnen 24 Stunden täglich, an allen Tagen im Jahr, zur Verfügung.',
      emergencyParagraph2: 'Sie erreichen uns unter +386 41 606 346.',
      emergencyParagraph3: 'Bitte verwenden Sie diese Telefonnummer ausschließlich in dringenden Fällen. Für alle nicht dringenden Angelegenheiten kontaktieren Sie uns bitte während der Bürozeiten über die allgemeinen Kontaktdaten der Kanzlei.',
      emergencyPhoneRaw: '+38641606346',
      emergencyPhoneDisplay: '+386 41 606 346',
      emergencyPhoneNote: 'Nur für Notfälle',
    },
    about: {
      title: 'Wo wir sind',
      location: 'Standort',
      subtitle: 'Besuchen Sie uns in Mengeš, in unmittelbarer Nähe des Špas-Theaters und der Gemeinde Mengeš.',
      cardTitle: 'Anwaltskanzlei BM',
      addressTitle: 'Adresse',
      addressLine1: 'Slovenska cesta 24',
      addressLine2: '1234 Mengeš, Slowenien',
      mapLinkLabel: 'In Google Maps öffnen ->',
      phoneTitle: 'Telefon',
      officePhone: '040-811-830 (Kanzlei)',
      emergencyPhone: '+386 41 606 346 (Notfälle 24/7)',
      emailTitle: 'E-Mail',
      email: 'tajnistvo@op-bm.si',
      hoursTitle: 'Bürozeiten',
      hoursText: 'Mandanten werden nach vorheriger Vereinbarung empfangen.',
      directions: [
        {
          title: 'Mit dem Auto',
          text: 'Die Kanzlei befindet sich im 1. Stock in der Slovenska cesta 24. Kostenlose Parkplätze (bis zu 2 Stunden) stehen auf dem zentralen Parkplatz hinter dem Gebäude zur Verfügung.',
        },
        {
          title: 'Orientierung',
          text: 'In unmittelbarer Nähe des Špas-Theaters und der Gemeinde Mengeš. Der Eingang befindet sich auf der Rückseite des Gebäudes über den Innenparkplatz bei Mestna kavarna Mesing.',
        },
        {
          title: 'Termin',
          text: 'Mandanten werden nach vorheriger Vereinbarung empfangen. Rufen Sie 040-811-830 an oder schreiben Sie an tajnistvo@op-bm.si.',
        },
      ],
      photoTitle: 'Slovenska cesta 24, Mengeš',
      photoSubtitle: '1. Stock · Eingang auf der Rückseite des Gebäudes',
      address: 'Die Anwaltskanzlei befindet sich im 1. Stock eines Geschäfts- und Wohngebäudes in der Slovenska cesta 24 in Mengš in unmittelbarer Nähe des Špas-Theaters und der Gemeinde Mengš.',
      entrance: 'Der Eingang zur Anwaltskanzlei befindet sich auf der Rücks​eite des Gebäudes durch den zentralen inneren Parkplatz bei der Mestna kavarni Mesing.',
      parking: 'Kostenloses Parken (bis zu zwei Stunden) für Besucher steht auf dem Parkplatz (Zentralparkplatz) vor dem Gebäude zur Verfügung.',
    },
    aboutUs: {
      title: 'Über uns',
      intro: 'Wir stellen unser Anwaltsteam und die wichtigsten Informationen zu den Mitgliedern unserer Kanzlei vor.',
      noImage: 'Bild folgt',
      sectionLabel: 'Über uns',
      mainTitle: 'Unser Team',
      teamLabel: 'Team',
      teamTitle: 'Kanzleimitarbeiter',
      achievementsToggle: 'Erfolge und Publikationen',
      yearsExperienceValue: '30+',
      yearsExperienceLabel: 'Jahre Erfahrung',
      martinHighlights: [
        { title: 'Rechtsanwalt und Mediator', text: 'Strategische Vertretung und Mediation.' },
        { title: 'Ehemaliger Richter', text: 'Erfahrung in gerichtlicher Entscheidungsfindung.' },
        { title: 'Persönlicher Ansatz', text: 'Durchdachte und verantwortungsvolle Vertretung.' },
        { title: 'Nach Vereinbarung', text: 'Mandanten nur nach vorheriger Terminvereinbarung.' },
      ],
      mojcaTags: ['Familienrecht', 'Arbeitsrecht', 'Strafrecht', 'SL / EN / HR / SR / DE'],
      thirdTags: ['Kanzleiorganisation', 'Administration', 'SL / EN'],
      martin: {
        role: 'Martin Bregant, Rechtsanwalt, Mediator und Geschäftsführer',
        paragraphs: [
          'Martin Bregant hat im Jahr 2025 das 30-jährige Jubiläum seiner selbstständigen anwaltlichen Tätigkeit begangen. Seine berufliche Laufbahn begann er als Richter am Bezirksgericht Ljubljana und später auch am Bezirksgericht Kamnik. Im Jahr 1995 beendete er seine richterliche Laufbahn und setzte seinen beruflichen Weg als Rechtsanwalt fort.',
          'Seinen Mandanten bietet er eine durchdachte, strategische und verantwortungsvolle rechtliche Vertretung. Er stützt sich auf eine gründliche rechtliche Beurteilung des Falls unter Berücksichtigung der Rechtsprechung, der Beweismöglichkeiten und der realen Prozessrisiken. Aufgrund seiner langjährigen Erfahrung in Justiz und Anwaltschaft kann er den Fall auch aus Sicht der gerichtlichen Entscheidungsfindung beurteilen, was eine sorgfältige Strategiaplanung ermöglicht.',
          'Er ist sich bewusst, dass rechtliche Verfahren für den Einzelnen einen wichtigen Wendepunkt im Leben darstellen, deshalb bemüht er sich um eine fachliche und zugleich menschliche Bearbeitung jeder Angelegenheit.',
          'Neben seiner anwaltlichen Tätigkeit ist er auch als Mediator tätig. Mandanten können ihn mit der Durchführung von Mediationsverfahren beauftragen, wenn sie eine Streitigkeit friedlich, rasch und durch eine Einigung lösen möchten, die die Interessen aller Beteiligten berücksichtigt. Seine Erfahrungen aus Justiz und Anwaltschaft ermöglichen ihm eine unparteiische und effiziente Führung des Mediationsprozesses.',
          'Mandanten werden nach vorheriger Vereinbarung empfangen.',
        ],
        contactTitle: 'Kontakt:',
        emailLabel: 'E-Mail:',
        phoneLabel: 'Telefon:',
        email: 'martin.bregant@siol.net',
        phone: '040-811-830',
      },
      mojca: {
        role: 'Mojca Musič, Mag. iur., Rechtsanwaltsanwärterin und Richteramtsanwärterin',
        paragraphs: [
          'Mojca Musič ist in der Kanzlei als Rechtsanwaltsanwärterin tätig und absolviert gleichzeitig ihr Richteramtspraktikum am Bezirksgericht Ljubljana.',
          'Im Jahr 2024 schloss sie unter der Betreuung von ao. Prof. mag. can. ius. Dr. Borut Holcman, univ. dipl. theol., moralno juridični spec., ihr Masterstudium an der Juristischen Fakultät der Universität Maribor mit Auszeichnung im Bereich der Geschichte der Anwaltschaft ab. Derzeit ist sie Doktorandin im Bereich der Rechtsgeschichte, wo sie die Rolle der Anwaltschaft im Rechtsprozess weiter erforscht.',
          'In ihrer Arbeit beschäftigt sie sich vor allem mit Familien-, Arbeits- und Strafrecht, wobei sie dem Familienrecht besondere fachliche und persönliche Hingabe widmet. Sie ist überzeugt, dass dieses Rechtsgebiet unmittelbar die Würde, Sicherheit und grundlegenden Lebensumstände des Einzelnen betrifft. Sie verfügt über ein ausgeprägtes Einfühlungsvermögen.',
          'Bei ihrer Arbeit verwendet sie aktiv Slowenisch, Englisch, Kroatisch und Serbisch sowie umgangssprachlich auch Deutsch.',
          'Mandanten werden nach vorheriger Vereinbarung empfangen.',
        ],
        contactTitle: 'Kontakt:',
        emailLabel: 'E-Mail:',
        phoneLabel: 'Telefon:',
        email: 'mojca.remic@op-bm.si',
        phone: '040-811-830',
        achievementsTitle: 'ERFOLGE:',
        achievements: [
          '2017 – 1. Platz beim Literaturwettbewerb der Studentenvereinigung der Juristischen Fakultät UM mit dem Essay „Urteile der Gerichte der Republik Slowenien vor dem Europäischen Gerichtshof für Menschenrechte (EGMR)“ und Veröffentlichung eines Artikels in der Zeitschrift Iusto Iure',
          '2019 – 1. Platz beim Mediationswettbewerb (Bereich Arbeitsrecht), organisiert von der Juristischen Fakultät der Universität Maribor',
          '2020 - Mitwirkung am Projekt „ŠIPK – Messung der Eigenschaften eines Elektromotors für den Antrieb eines Elektrofahrzeugs“ an der Fakultät für Energietechnik der Universität Maribor; Schwerpunkt auf der Prüfung der Konformität von Produkten mit nationalen und europäischen Vorschriften sowie der Vorbereitung technischer Dokumentation.',
          '2020 - Teilnahme an der Konferenz „What are human rights?“, Veranstalter: United for Human Rights (UHR)',
          '2021 – Mitwirkung am Projekt Amicus Curiae (Praxis am Verwaltungsgericht der Republik Slowenien und am Bezirksgericht Maribor)',
          '2026 - Projektleiterin des Projekts „Konstitutive Berufe in der Justiz“, durchgeführt im Rahmen der öffentlichen Ausschreibung „Problembasiertes Lernen von Studierenden im Arbeitsumfeld: Wirtschaft, Nichtwirtschaft und Non-Profit-Sektor im lokalen/regionalen Umfeld 2024-2027 (PUŠ im Arbeitsumfeld 2024-2027) - 2. Ausschreibung“.',
        ],
        bibliographyTitle: 'PERSÖNLICHE BIBLIOGRAFIE:',
        bibliography: [
          'REMIC, Mojca. Ali delavec lahko odkloni službeno pot, ker ne želi opraviti obveznega cepljenja?. Pravna praksa : PP. [Gedruckte Ausgabe]. 29. Aug. 2024, Jahr 42, Nr. 30/31, S. 20-21, mit Autorenfoto. ISSN 0352-0730. [COBISS.SI-ID 205701891]',
          'REMIC, Mojca. "Beschirmern vor vnrecht" - vloga odvetnika v procesu skozi zgodovino : magistrsko delo. Maribor: [M. Remic], 2024. 1 Online-Quelle (1 PDF-Datei, 76 S.). Digitale Bibliothek der Universität Maribor – DKUM. [COBISS.SI-ID 199769859]',
          'REMIC, Mojca. Pot k digitalizaciji pravosodja v EU : uredba (EU) 2020/1784 o vročanju sodnih in izvednsodnih pisanj v civilnih ali gospodarskih zadevah. Pravna praksa : PP. [Gedruckte Ausgabe]. 10. Okt. 2024, Jahr 43, Nr. 37/38, S. 7-8, mit Autorenfoto. ISSN 0352-0730. [COBISS.SI-ID 211008771]',
          'REMIC, Mojca. Pogodba o dosmrtnem preživljanju med zakoncema. Pravna praksa : PP. [Gedruckte Ausgabe]. 6. März 2025, Jahr 44, Nr. 9, S. 9-10, mit Autorenfoto. ISSN 0352-0730. [COBISS.SI-ID 228136707]',
        ],
      },
      third: {
        role: 'Maša Rožman, Dipl.-Jur., Kanzleileiterin',
        paragraphs: [
          'Maša Rožman ist als Leiterin der Anwaltskanzlei beschäftigt.',
          'Sie erledigt ihre Arbeit fachkundig, verantwortungsvoll und mit ausgeprägtem Gespür für die Bedürfnisse der Mandanten. Als Kanzleileiterin übernimmt sie alle organisatorischen und administrativen Aufgaben und sorgt dafür, dass die Arbeit in der Kanzlei reibungslos und ungestört abläuft.',
          'Im Jahr 2023 schloss sie ihr Studium an der Juristischen Fakultät der Universität Maribor mit Auszeichnung ab, wo sie derzeit ihr Masterstudium abschließt.',
          'Sie zeichnet sich durch Genauigkeit, strategisches Denken und einen persönlichen Ansatz aus, mit dem sie langfristige und vertrauensvolle Beziehungen aufbaut.',
          'In ihrer Arbeit verwendet sie aktiv Slowenisch und Englisch.',
        ],
        contactTitle: 'Kontakt:',
        emailLabel: 'E-Mail:',
        phoneLabel: 'Telefon:',
        email: 'tajnistvo@op-bm.si',
        phone: '040-811-830',
      },
    },
    contact: {
      title: 'Kontakt',
      intro: 'Kontaktieren Sie uns für juristische Beratung: ',
      email: 'info@novak-partner.de',
      phone: '+386 1 234 5678',
      workingHours: {
        title: 'Öffnungszeiten',
        hours: 'Unser Büro ist montags bis freitags von 8:00 bis 16:00 Uhr geöffnet, freitags jedoch nur bis 13:00 Uhr.',
        reservation: 'Ein Treffen im Büro erfordert eine vorherige Reservierung per Telefon oder über das untenstehende Kontaktformular.',
        response: 'Ihre Fragen beantworten wir schnellstmöglich.',
        documents: 'Bitte bringen Sie zu Ihrem vereinbarten Termin alle verfügbaren Unterlagen zu Ihrem Fall mit. Nach dem Gespräch werden Ihnen die ungefähren Kosten für Ihren Fall mitgeteilt, und wenn Sie sich für unsere Vertretung entscheiden, unterzeichnen Sie eine Vollmacht, auf deren Grundlage wir sofort mit der Arbeit beginnen können.',
      },
      form: {
        name: 'Name und Nachname',
        namePlaceholder: 'Ihr Name und Nachname',
        email: 'E-Mail',
        emailPlaceholder: 'ihre@email.example',
        subject: 'Betreff',
        subjectPlaceholder: 'Kurze Zusammenfassung Ihrer Anfrage',
        message: 'Nachricht',
        messagePlaceholder: 'Details Ihrer Frage',
        submit: 'Senden',
      },
      status: {
        required: 'Bitte füllen Sie alle Felder aus.',
        invalidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
        sending: 'Nachricht wird gesendet ...',
        success: 'Die Nachricht wurde erfolgreich gesendet.',
        error: 'Fehler beim Senden. Bitte versuchen Sie es erneut.',
        botDetected: 'Senden fehlgeschlagen.',
      },
    },
    practiceAreas: {
      title: 'Tätigkeitsbereiche',
      intro: 'Unsere Anwaltskanzlei deckt ein breites Spektrum von Rechtsbereichen ab.',
      areas: [
        {
          title: 'HANDELS- UND VERTRAGSRECHT UND GESCHÄFTSBEZIEHUNGEN',
          points: [
            'Beratung bei Fragen im Zusammenhang mit in- und ausländischen Geschäftsbeziehungen',
            'Erstellung und Überprüfung von Handelsverträgen',
            'Unterstützung bei Verhandlungen',
            'Vertretung in Gerichtsverfahren, die aus Verträgen und Geschäftsbeziehungen entstehen',
            'Durchführung von Due-Diligence-Prüfungen',
          ]
        },
        {
          title: 'HANDELSSTREITIGKEITEN UND FORDERUNGSEINTREIBUNG',
          points: [
            'Vertretung in allen Handelsstreitigkeiten und Mediationen',
            'Beratung bei der Regelung von Gläubiger-Schuldner-Verhältnissen',
            'Vertretung in Zwangsvollstreckungsverfahren',
          ]
        },
        {
          title: 'KONKURS- UND INSOLVENZRECHT',
          points: [
            'Beratung in Konkurs- und Zwangsausgleichs- sowie Liquidationsverfahren',
            'Anmeldung von Forderungen, Aussonderungsrechte und Absonderungsrechte der Gläubiger',
            'Vertretung in anderen mit Konkurs- und Zwangsausgleichsverfahren verbundenen Verfahren',
          ]
        },
        {
          title: 'HANDELSSTRAFSRECHT',
          points: [
            'Erstellung von Strafanzeigen',
            'Erstellung und Einreichung von Privatklage',
            'Erstellung von Vermögensschadensersatzansprüche der Geschädigten',
          ]
        },
        {
          title: 'IMMOBILIENRECHT',
          points: [
            'Beratung, Erstellung oder Überprüfung aller Arten von Verträgen im Zusammenhang mit Immobilien',
            'Mitwirkung bei der Begründung von Dienstbarkeiten und anderen Rechten',
            'Vertretung in Streitigkeiten im Zusammenhang mit Immobilien sowie mit Immobilien verbundenen Rechten und Mietverhältnissen',
            'Vertretung in Besitzstreitigkeiten und außergerichtlichen Verfahren für Grenzregulierung, Aufteilung des Miteigentums und Bestimmung öffentlicher Wege',
            'Beratung bei der Regelung von Wohnungs- und Mietverhältnissen',
            'Erstellung von Höchstpersonengebundenen Rechten',
            'Vorschlag von Eintragungen im Grundbuch',
          ]
        },
        {
          title: 'OBLIGATIONENRECHT',
          points: [
            'Beratung und Vertretung in Schadensersatzstreitigkeiten',
            'Erstellung von Verträgen des Schuldrechts',
            'Beratung und Vertretung in Schuldrechtsstreitigkeiten',
          ]
        },
        {
          title: 'ERBRECHT',
          points: [
            'Beratung und Vertretung in erbschaftlichen Fragen, Nachlassverfahren und Erbstreitigkeiten',
            'Erstellung von Testamenten',
            'Erstellung von Übergabeverträgen, Fruchtgenussverträgen und Verträgen zur Sofortunterlhaltsgewährung',
          ]
        },
        {
          title: 'FAMILIENRECHT',
          points: [
            'Beratung zu rechtlichen Fragen der Auflösung von Ehebindungen und der Trennung außerehelicher Partner, Vermögensaufteilung und Unterhaltsgebührenbestimmung',
            'Vertretung in Ehescheidungsverfahren und Vermögensaufteilungsverfahren',
          ]
        },
        {
          title: 'ARBEITSRECHT',
          points: [
            'Beratung in Arbeitsrechtsfragen',
            'Erstellung von internen allgemeinen Betriebsvereinbarungen des Arbeitgebers',
            'Beratung und Vertretung in Kündigungsverfahren',
            'Vertretung in sonstigen Arbeitsrechtstreitigkeiten',
            'Mitwirkung bei der Durchführung von Disziplinarverfahren',
          ]
        },
        {
          title: 'VERWALTUNGSVERFAHREN UND VERWALTUNGSSTREITIGKEITEN',
          points: [
            'Beratung und Mitwirkung bei Inspektionsverfahren',
            'Erstellung und Einreichung von Klagen in Verwaltungsstreitigkeiten',
          ]
        },
      ]
    },
    documents: {
      title: 'Allgemeine Bedingungen',
      intro: 'Rechtsanwalt Martin Bregant (im Folgenden: Rechtsanwalt) ist Mitglied der Rechtsanwaltskammer Sloweniens und berechtigt, anwaltliche Leistungen nach der jeweils geltenden Rechtsanwaltstarifordnung der Rechtsanwaltskammer Sloweniens (im Folgenden: Tarifordnung) abzurechnen, sofern mit dem Mandanten keine abweichende schriftliche Vereinbarung getroffen wurde.',
      sections: [
        {
          title: 'Entstehung des Mandatsverhältnisses',
          paragraphs: [
            'Der Rechtsanwalt ist nicht verpflichtet, jede angebotene Vollmacht anzunehmen. Das Mandatsverhältnis entsteht, wenn der Rechtsanwalt die Annahme der Vollmacht ausdrücklich bestätigt oder dem Mandanten anderweitig schriftlich bestätigt, dass er die Vertretung übernommen bzw. mit der Erbringung rechtlicher Leistungen begonnen hat.',
            'Im Zweifel gilt das Mandat als am Tag der schriftlichen Bestätigung oder am Tag des tatsächlichen Beginns der beauftragten Leistungen mit Wissen und Einverständnis des Mandanten angenommen.',
          ],
        },
        {
          title: 'Art der Abrechnung von Leistungen',
          paragraphs: [],
        },
        {
          title: '1. Anwendung der Tarifordnung',
          paragraphs: [
            'Sofern zwischen dem Rechtsanwalt und dem Mandanten keine besondere Vereinbarung über eine andere Abrechnungsart getroffen wurde, werden Leistungen nach den Bestimmungen der Tarifordnung abgerechnet.',
          ],
        },
        {
          title: '2. Vereinbarung einer abweichenden Vergütung',
          paragraphs: [
            'Der Rechtsanwalt und der Mandant können nach den geltenden Vorschriften eine schriftliche Vereinbarung über eine abweichende Vergütungsart treffen (im Folgenden: besondere Vereinbarung).',
            'Schlägt der Rechtsanwalt dem Mandanten einen Stundensatz vor und stimmt der Mandant zu (ausdrücklich oder konkludent, indem er den Arbeitsbeginn ohne Widerspruch zulässt), gilt eine besondere Vereinbarung über die Abrechnung nach Stundensatz als geschlossen. Der Stundensatz wird dem Mandanten stets schriftlich bestätigt (z. B. per E-Mail). Diese allgemeinen Bedingungen sind Bestandteil einer solchen Vereinbarung, sofern nicht ausdrücklich etwas anderes vereinbart ist.',
            'Ist ein Pauschalbetrag vereinbart, werden Leistungen, die den vereinbarten Umfang überschreiten, nach dem vereinbarten Stundensatz oder - falls dieser nicht festgelegt ist - nach der Tarifordnung abgerechnet.',
            'Soweit eine einzelne Leistung nicht von der besonderen Vereinbarung erfasst ist, gilt dafür die Tarifordnung.',
          ],
        },
        {
          title: 'Stundensatz und Kosten',
          paragraphs: [
            'Der Rechtsanwalt kann jährlich eine informative Preisliste erstellen und dabei Inflation, Leistungsumfang sowie andere relevante Umstände berücksichtigen.',
            'Je nach Art und Komplexität der einzelnen Angelegenheit kann der Rechtsanwalt einen Standard- oder erhöhten Stundensatz vorschlagen. Die endgültige Höhe ist Gegenstand der Vereinbarung mit dem Mandanten.',
            'Die kleinste Abrechnungseinheit beim Stundensatz beträgt 30 Minuten.',
            'Zusätzlich zum Honorar behält sich der Rechtsanwalt das Recht vor, Materialkosten in Höhe von 3 % des Leistungswertes zu berechnen, sofern nichts anderes vereinbart wurde.',
            'Sofern nichts anderes bestimmt ist, werden Postsendungen pauschal bzw. nach tatsächlichen Kosten abgerechnet, wenn diese von den genannten Beträgen abweichen:',
          ],
          bullets: [
            '5 EUR für ein Einschreiben innerhalb Sloweniens',
            '10 EUR für eine Sendung innerhalb der EU',
            '20 EUR für eine Sendung außerhalb der EU',
          ],
        },
        {
          title: 'Rechnungsstellung und Zahlungsbedingungen',
          paragraphs: [
            'Sofern nichts anderes vereinbart ist, stellt der Rechtsanwalt Rechnungen monatlich für die im vorangegangenen Zeitraum erbrachten Leistungen oder nach Abschluss einer sachlich abgeschlossenen Verfahrensphase aus.',
            'Die Zahlungsfrist beträgt 8 Tage ab Rechnungsdatum, sofern nichts anderes vereinbart ist.',
            'Bei Zahlungsverzug ist der Mandant verpflichtet, gesetzliche Verzugszinsen sowie etwaige Inkassokosten zu tragen.',
            'Wird der Rechtsanwalt umsatzsteuerpflichtig, wird auf alle Leistungen Umsatzsteuer gemäß den geltenden Vorschriften berechnet.',
            'Der Rechtsanwalt kann nach eigenem Ermessen das berechnete Honorar reduzieren, jedoch nicht einseitig über die getroffene Vereinbarung hinaus erhöhen.',
            'Der Rechtsanwalt ist berechtigt, aus Beträgen, die er für Rechnung des Mandanten erhält, fällige Forderungen aus seinen Leistungen zu begleichen, hierüber eine entsprechende Rechnung mit Zahlungskennzeichnung auszustellen und den Restbetrag an den Mandanten auszuzahlen.',
          ],
        },
        {
          title: 'Hinweis zur Kostenerstattung in Verfahren',
          paragraphs: [
            'Gerichte und andere Behörden erkennen und bemessen Vertretungskosten in der Regel in der nach der Tarifordnung bestimmten Höhe, unabhängig von einer etwaigen abweichenden Vereinbarung zwischen Rechtsanwalt und Mandant.',
          ],
        },
        {
          title: 'Widerruf der Vollmacht',
          paragraphs: [
            'Widerruft der Mandant die Vollmacht ohne berechtigten Grund vor Abschluss der Angelegenheit, ist er verpflichtet, den Wert der bis zum Widerruf bereits erbrachten Leistungen und entstandenen Kosten zu begleichen, sofern nicht ausdrücklich etwas anderes vereinbart wurde.',
            'Für etwaige Streitigkeiten ist das Gericht am Sitz des Rechtsanwalts örtlich zuständig.',
          ],
        },
        {
          title: 'Vertraulichkeit und Datenschutz',
          paragraphs: [
            'Alle Informationen und Dokumente, die zwischen dem Rechtsanwalt und dem Mandanten ausgetauscht werden, gelten als vertraulich.',
            'Zur Prüfung eines möglichen Interessenkonflikts darf der Rechtsanwalt das Bestehen des Mandatsverhältnisses und die allgemeine Natur der Angelegenheit offenlegen, nicht jedoch den Inhalt vertraulicher Daten.',
            'Bei der Leistungserbringung kann es zur Verarbeitung personenbezogener Daten gemäß geltendem europäischem und nationalem Recht kommen. Der Rechtsanwalt verwendet personenbezogene Daten ausschließlich zur Erbringung rechtlicher Leistungen, schützt sie als vertraulich und gewährleistet angemessene Sicherheitsmaßnahmen.',
            'Nach Beendigung des Mandatsverhältnisses werden personenbezogene Daten zurückgegeben oder vernichtet, soweit dies rechtlich zulässig und mit den gesetzlichen Vorschriften vereinbar ist.',
          ],
        },
        {
          title: 'Haftungsbeschränkung',
          paragraphs: [
            'Die Haftung des Rechtsanwalts auf Schadensersatz ist auf die Summe der gezahlten Honorare für Leistungen beschränkt, die in den 30 Tagen vor dem Ereignis erbracht wurden, aus dem sich eine mögliche Haftung ergibt.',
            'Der Rechtsanwalt haftet nicht für mittelbare Schäden, entgangenen Gewinn, Umsatzausfall oder sonstige Folgeschäden.',
            'Der Rechtsanwalt verfügt über eine verpflichtende Berufshaftpflichtversicherung bei Wiener Städtische im Rahmen des Versicherungsschemas der Rechtsanwaltskammer Sloweniens.',
          ],
        },
      ],
    },
    freeLegalAid: {
      title: 'Kostenlose Rechtshilfe',
      paragraphs: [
        'In unserer Kanzlei bieten wir auch die Vertretung von Mandanten im Rahmen der kostenlosen Rechtshilfe (BPP) an.',
        'Mit der kostenlosen Rechtshilfe wird das Recht auf gerichtlichen Rechtsschutz für Personen verwirklicht, die dieses Recht ohne Beeinträchtigung ihres eigenen Unterhalts und des Unterhalts ihrer Familie nicht ausüben könnten. Berechtigten, die die finanziellen und inhaltlichen Voraussetzungen erfüllen, ermöglicht sie in erster Linie gerichtlichen Rechtsschutz, ausnahmsweise auch vorgerichtliche Beratung und den Abschluss von Vergleichen.',
        'Bevor der Rechtsanwalt mit der Arbeit beginnt, benötigt er den Bescheid über kostenlose Rechtshilfe und die Zuweisung (Napotnica) für kostenlose Rechtshilfe, die vom fachlichen Dienst für kostenlose Rechtshilfe beim Gericht ausgestellt werden.',
        'Wir unterstützen Mandanten auch beim Ausfüllen und Vorbereiten des Antrags auf Gewährung kostenloser Rechtshilfe (BPP), einschließlich der Prüfung der erforderlichen Unterlagen und Beratung zur Erfüllung der finanziellen Voraussetzungen.',
      ],
      linksTitle: 'Der Antrag kann elektronisch über das e-Uprava-Portal oder schriftlich beim zuständigen Gericht eingereicht werden:',
      links: [
        {
          label: 'https://e-uprava.gov.si/podrocja/vloge/vloga.html?id=1225',
          url: 'https://e-uprava.gov.si/podrocja/vloge/vloga.html?id=1225',
        },
        {
          label: 'https://e-uprava.gov.si/si/podrocja/drzava-druzba/pravna-pomoc/brezplacna-pravna-pomoc',
          url: 'https://e-uprava.gov.si/si/podrocja/drzava-druzba/pravna-pomoc/brezplacna-pravna-pomoc',
        },
      ],
    },
    mediation: {
      title: 'Mediation',
      paragraphs: [
        'In unserer Kanzlei legen wir großen Wert auf alternative Streitbeilegung, damit Mandanten eine gerichtliche Auseinandersetzung vermeiden können.',
        'Mediation ist ein vertrauliches und strukturiertes Verfahren zur einvernehmlichen Streitbeilegung, bei dem eine neutrale dritte Person - der Mediator - den Parteien hilft, eine gemeinsame Lösung zu finden. Ihr wesentlicher Vorteil liegt darin, dass die Parteien selbst eine Lösung gestalten, die ihre Interessen, Bedürfnisse und zukünftigen Beziehungen berücksichtigt, anstatt die Entscheidung dem Gericht zu überlassen.',
        'Rechtsanwalt Martin Bregant ist außerdem ein erfahrener und effizienter Mediator, der sowohl für gerichtliche als auch außergerichtliche Streitigkeiten beauftragt werden kann. Als Mediator handelt er unparteiisch und sorgt für einen ausgewogenen, konstruktiven Dialog zwischen den Parteien.',
        'Das Mediationsverfahren ist in der Regel schneller und kostengünstiger als ein Gerichtsverfahren und bietet zugleich mehr Flexibilität und Vertraulichkeit. Eine erzielte Einigung kann die Grundlage für einen gerichtlichen Vergleich oder einen vollstreckbaren Vergleich sein, sofern sich die Parteien dafür entscheiden.',
        'Wenn Sie Mediation als Weg zur Streitbeilegung in Betracht ziehen, beraten wir Sie gerne hinsichtlich der Eignung des Verfahrens und der Möglichkeiten seiner Durchführung.',
      ],
      bulletsTitle: 'Mediation ist besonders sinnvoll:',
      bullets: [
        'wenn die Parteien eine korrekte oder dauerhafte Beziehung erhalten möchten (z. B. in familien-, partner- oder geschäftsbezogenen Verhältnissen)',
        'wenn eine schnelle und diskrete Streitlösung wichtig ist',
        'wenn die Parteien aktiv an der Ausgestaltung der Vereinbarung mitwirken möchten',
        'wenn eine Einigung möglich ist, die Kommunikation zwischen den Parteien jedoch erschwert ist',
      ],
      contactTitle: 'Kontakt',
      emailLabel: 'E-Mail:',
      email: 'tajnistvo@op-bm.si',
      phoneLabel: 'Telefon:',
      phone: '040-811-830',
      linksTitle: 'Mehr zum Mediationsverfahren:',
      links: [
        {
          label: 'https://www.odv-zb.si/mediacijski-center/pogosta-vprasanja-in-odgovori/#htoc-v-katerih-primerih-je-mediacija-smiselna',
          url: 'https://www.odv-zb.si/mediacijski-center/pogosta-vprasanja-in-odgovori/#htoc-v-katerih-primerih-je-mediacija-smiselna',
        },
        {
          label: 'https://nasodiscu.si/mediacija',
          url: 'https://nasodiscu.si/mediacija',
        },
      ],
    },
    privacy: {
      title: "Datenschutzerklärung",
      intro: "Diese Erklärung beschreibt, welche personenbezogenen Daten wir über diese Website verarbeiten, zu welchem Zweck und auf welcher Rechtsgrundlage, an wen wir sie weitergeben und welche Rechte Ihnen zustehen.",
      updated: "Letzte Änderung: 14.10.2026",
      sections: [
        {
          title: "1. Verantwortlicher",
          paragraphs: [
            "Verantwortlicher für die über diese Website verarbeiteten personenbezogenen Daten ist Odvetniška pisarna Martina Breganta (Anwaltskanzlei Martin Bregant), Slovenska cesta 24, 1234 Mengeš, Slowenien.",
            "Registernummer: 2511975000. Steuernummer: 10045503.",
            "In Datenschutzangelegenheiten erreichen Sie uns unter tajnistvo@op-bm.si und unter der Telefonnummer 040 811 830.",
          ],
        },
        {
          title: "2. Welche Daten verarbeitet werden",
          paragraphs: [
            "Die Website erfordert keine Registrierung und legt keine Benutzerkonten an. Personenbezogene Daten verarbeiten wir nur, wenn Sie sie uns selbst übermitteln:",
          ],
          bullets: [
            "Kontaktformular: Name, E-Mail-Adresse, Betreff und Inhalt der Nachricht.",
            "Direkter Kontakt: Daten, die Sie uns übermitteln, wenn Sie uns anrufen oder an die auf dieser Website angegebene Adresse schreiben.",
            "Technische Daten: Beim Besuch werden Verbindungen zu den unter Punkt 5 beschriebenen externen Diensten aufgebaut, die Ihre IP-Adresse erhalten.",
          ],
          extra: [
            "Die Website enthält keine Analysewerkzeuge, Besucherzähler, Werbe-Tracker oder Profilbildung. Wir treffen auf Grundlage Ihrer Daten keine automatisierten Entscheidungen.",
          ],
        },
        {
          title: "3. Zweck und Rechtsgrundlage der Verarbeitung",
          bullets: [
            "Beantwortung Ihrer Anfrage und gegebenenfalls Anbahnung eines Mandatsverhältnisses — Rechtsgrundlage ist die Durchführung vorvertraglicher Maßnahmen auf Ihre Anfrage (Art. 6 Abs. 1 lit. b DSGVO).",
            "Betrieb, Sicherheit und Schutz der Website vor Missbrauch — Rechtsgrundlage ist unser berechtigtes Interesse (Art. 6 Abs. 1 lit. f DSGVO).",
            "Erfüllung gesetzlicher Pflichten des Anwaltsberufs — Rechtsgrundlage ist die rechtliche Verpflichtung (Art. 6 Abs. 1 lit. c DSGVO).",
          ],
          paragraphs: [
            "Die Übermittlung von Daten über das Kontaktformular ist weder gesetzlich noch vertraglich vorgeschrieben. Ohne diese Angaben können wir Ihre Nachricht lediglich nicht beantworten.",
          ],
        },
        {
          title: "4. Kontaktformular",
          paragraphs: [
            "Wenn Sie das Kontaktformular absenden, werden die eingegebenen Daten aus Ihrem Browser über einen Dienst zum Versand von E-Mails aus Webformularen (EmailJS) an das Postfach der Kanzlei zugestellt. Der Anbieter dieses Dienstes handelt insoweit als Auftragsverarbeiter.",
            "Das Formular enthält ein verstecktes Feld zur Spam-Abwehr, das von Besuchern nicht ausgefüllt wird; ein ausgefülltes Feld deutet auf automatisierten Versand hin und die Nachricht wird nicht gesendet. In diesem Feld werden keine personenbezogenen Daten verarbeitet.",
            "Ihre Nachricht erreicht das Postfach der Kanzlei und wird vertraulich behandelt, im Einklang mit der anwaltlichen Verschwiegenheitspflicht.",
            "Bitte übermitteln Sie über das Kontaktformular keine besonderen Kategorien personenbezogener Daten und keine Einzelheiten Ihres Falls. Vereinbaren Sie dafür bitte ein persönliches oder telefonisches Gespräch.",
          ],
        },
        {
          title: "5. In die Website eingebundene externe Dienste",
          paragraphs: [
            "Die Website nutzt zwei Dienste von Google, die direkt von Google-Servern geladen werden. Dabei werden Google Ihre IP-Adresse und grundlegende Browserdaten offengelegt, und zwar bereits bevor Sie etwas anklicken. Auf den Umfang dieser Verarbeitung haben wir keinen Einfluss.",
          ],
          bullets: [
            "Google Fonts: Schriftarten werden von den Servern fonts.googleapis.com und fonts.gstatic.com geladen. Dies geschieht auf jeder Unterseite.",
            "Google Maps: Auf der Unterseite »Wo wir sind« ist eine Karte mit dem Standort der Kanzlei eingebettet. Beim Öffnen dieser Unterseite wird eine Verbindung zu Google-Servern hergestellt, die in Ihrem Browser Cookies setzen können.",
          ],
          extra: [
            "Die Datenschutzerklärung von Google ist unter https://policies.google.com/privacy abrufbar. Wenn Sie diese Verbindungen nicht herstellen möchten, können Sie einen Browser oder eine Erweiterung verwenden, die Anfragen an Google-Domains blockiert; die Website funktioniert auch dann, lediglich mit Systemschrift und ohne Kartendarstellung.",
          ],
        },
        {
          title: "6. Cookies und lokaler Speicher",
          paragraphs: [
            "Diese Website setzt selbst keine Cookies und verwendet keine Cookies für Analyse oder Werbung.",
            "Im lokalen Speicher Ihres Browsers wird eine einzige Angabe abgelegt — die gewählte Sprache der Oberfläche (Slowenisch, Deutsch oder Englisch) — damit Sie diese beim nächsten Besuch nicht erneut wählen müssen. Diese Angabe verbleibt in Ihrem Browser, wird nicht an einen Server übermittelt und erlaubt keine Identifizierung. Sie können sie jederzeit durch Löschen der Browserdaten entfernen.",
            "Cookies können von Google beim Anzeigen der eingebetteten Karte gesetzt werden, wie unter Punkt 5 beschrieben.",
          ],
        },
        {
          title: "7. Speicherdauer",
          paragraphs: [
            "Über das Kontaktformular eingegangene Nachrichten bewahren wir 12 Monate ab der letzten Kommunikation auf und löschen sie anschließend.",
            "Kommt es aufgrund Ihrer Anfrage zu einem Mandatsverhältnis, werden die Daten im Rahmen der Fallakte nach den gesetzlichen und berufsrechtlichen Fristen aufbewahrt.",
          ],
        },
        {
          title: "8. Empfänger und Übermittlung in Drittländer",
          paragraphs: [
            "Wir verkaufen personenbezogene Daten nicht und geben sie nicht zu deren eigenen Zwecken an Dritte weiter.",
          ],
          bullets: [
            "Anbieter des Dienstes zum Versand von E-Mails aus Webformularen (Auftragsverarbeiter).",
            "E-Mail-Anbieter, in dessen Postfach Ihre Nachricht eingeht (Auftragsverarbeiter).",
            "Hosting-Anbieter der Website: Netlify (Netlify, Inc., USA).",
            "Google — im unter Punkt 5 beschriebenen Umfang.",
            "Zuständige Behörden, soweit gesetzlich vorgeschrieben.",
          ],
          extra: [
            "Einzelne der genannten Anbieter können Daten auch außerhalb des Europäischen Wirtschaftsraums verarbeiten. In diesem Fall erfolgt die Übermittlung auf Grundlage der in der Datenschutz-Grundverordnung vorgesehenen Mechanismen — Standardvertragsklauseln oder eines Angemessenheitsbeschlusses der Europäischen Kommission.",
          ],
        },
        {
          title: "9. Ihre Rechte",
          paragraphs: [
            "In Bezug auf Ihre personenbezogenen Daten haben Sie das Recht:",
          ],
          bullets: [
            "auf Auskunft über die von uns verarbeiteten Daten;",
            "auf Berichtigung unrichtiger und Vervollständigung unvollständiger Daten;",
            "auf Löschung, wenn für die Verarbeitung keine Grundlage mehr besteht;",
            "auf Einschränkung der Verarbeitung;",
            "auf Datenübertragbarkeit hinsichtlich der von Ihnen bereitgestellten Daten;",
            "auf Widerspruch gegen eine Verarbeitung, die auf unserem berechtigten Interesse beruht;",
            "auf Widerruf einer Einwilligung, sofern die Verarbeitung darauf beruht, wobei der Widerruf die Rechtmäßigkeit der bis dahin erfolgten Verarbeitung unberührt lässt.",
          ],
          extra: [
            "Ihre Rechte machen Sie per Nachricht an tajnistvo@op-bm.si geltend. Wir antworten spätestens innerhalb eines Monats nach Eingang Ihrer Anfrage.",
            "Sind Sie der Ansicht, dass die Verarbeitung Ihrer Daten gegen geltendes Recht verstößt, können Sie Beschwerde bei der Aufsichtsbehörde einlegen — dem Informationsbeauftragten der Republik Slowenien (Informacijski pooblaščenec).",
            "Bitte beachten Sie, dass der Zugang zu Daten, die der anwaltlichen Verschwiegenheitspflicht unterliegen, nach den berufsrechtlichen Vorschriften eingeschränkt sein kann.",
          ],
        },
        {
          title: "10. Datensicherheit",
          paragraphs: [
            "Die Website ist über eine verschlüsselte HTTPS-Verbindung erreichbar. Der Zugriff auf eingegangene E-Mails ist auf die mit der Sache befassten Personen der Kanzlei beschränkt und unterliegt der anwaltlichen Verschwiegenheitspflicht.",
            "Keine Datenübertragung über das Internet ist vollständig sicher; für die Übermittlung sensibler Daten empfehlen wir daher ein persönliches Gespräch.",
          ],
        },
        {
          title: "11. Änderungen dieser Erklärung",
          paragraphs: [
            "Wir können diese Erklärung ändern, wenn sich die Funktionsweise der Website oder die geltenden Vorschriften ändern. Maßgeblich ist die auf dieser Unterseite veröffentlichte Fassung; das Datum der letzten Änderung ist oben angegeben.",
          ],
        },
      ],
    },
    footer: {
      privacy: "Datenschutz",
      contact: 'Kontakt',
      location: 'Wo wir sind',
      accounts: 'Geschäftskonto',
      credit: '© %year% BM Anwälte',
    },
  },
  en: {
    topBar: {
      emergencyLine: 'For detention matters, available 24/7 at +386 41-606-346',
      emergencyPrefix: 'Emergency legal assistance 24/7 —',
      emergencyPhoneDisplay: '+386 41 606 346',
      emergencyPhoneRaw: '+38641606346',
    },
    header: {
      logo: 'BM Lawyers',
      home: 'Home',
      menu: "Menu",
      practiceAreas: 'Areas of Practice',
      documents: 'Terms and Conditions',
      freeLegalAid: 'Free Legal Aid',
      mediation: 'Mediation',
      aboutUs: 'About Us',
      about: 'Where We Are',
      contact: 'Contact',
    },
    home: {
      title: 'Law Office of Martin Bregant',
      titlePrefix: 'Legal support with',
      titleEmphasis: 'a personal approach',
      heroLabel: 'Mengeš, Slovenia',
      ctaContact: 'Contact',
      ctaPracticeAreas: 'Areas of Practice',
      statValue: '30+',
      statLabel: 'years of experience',
      trustItems: [
        { value: '150+', label: 'cases per year' },
        { value: '100%', label: 'individual approach' },
        { value: '24/7', label: 'emergency support' },
        { value: '3', label: 'languages (SL, DE, EN)' },
      ],
      approachLabel: 'Our approach',
      approachTitle: 'Excellence and Professionalism',
      approachSubtitle: 'Every case is handled comprehensively and individually.',
      approachSteps: [
        {
          title: 'Free initial consultation',
          text: 'If we take over your case, the first consultation is free of charge.',
        },
        {
          title: 'Individual analysis',
          text: 'We thoroughly review your case and present possible solutions for the specific matter.',
        },
        {
          title: 'Representation',
          text: 'With an individual approach, we represent you before courts and other authorities.',
        },
      ],
      approachQuote: '"We earn our clients’ trust through an individual approach and a comprehensive review of each case."',
      approachQuoteCite: '— Martin Bregant, Attorney',
      lead: 'BM Lawyers from Mengeš provides you with legal assistance regarding the enforcement of damages, collection of receivables, drafting of various contracts and represents you in court in civil, criminal, labor, commercial and family matters.\n\nIn our work, we strive for excellence and professionalism!\n\nWe gain our clients\' trust through an individual approach, a thorough and comprehensive examination of the individual case and the presentation of possible solutions in the specific matter.\n\nIn damages cases, we offer the possibility of free legal consultation.\n\nBM Lawyers',
      emergencyBadge: 'Available 24/7',
      emergencyTitle: 'Emergency Legal Assistance',
      emergencyParagraph1: 'In urgent situations requiring immediate legal assistance – especially in cases of deprivation of liberty, investigative actions (such as house or personal searches), crime scene inspections, decisions on detention, compulsory psychiatric hospitalization, and other non-deferrable matters – we are available 24 hours a day, every day of the year.',
      emergencyParagraph2: 'You can reach us at +386 41 606 346.',
      emergencyParagraph3: 'Please use this phone number strictly for urgent matters. For all non-urgent matters, please contact us during office hours using the general office contact details.',
      emergencyPhoneRaw: '+38641606346',
      emergencyPhoneDisplay: '+386 41 606 346',
      emergencyPhoneNote: 'Emergency use only',
    },
    about: {
      title: 'Where We Are',
      location: 'Location',
      subtitle: 'Visit us in Mengeš, near Špas Theater and the Municipality of Mengeš.',
      cardTitle: 'BM Law Office',
      addressTitle: 'Address',
      addressLine1: 'Slovenska cesta 24',
      addressLine2: '1234 Mengeš, Slovenia',
      mapLinkLabel: 'Open in Google Maps ->',
      phoneTitle: 'Phone',
      officePhone: '040-811-830 (office)',
      emergencyPhone: '+386 41 606 346 (emergency 24/7)',
      emailTitle: 'Email',
      email: 'tajnistvo@op-bm.si',
      hoursTitle: 'Office Hours',
      hoursText: 'Clients are received by prior appointment.',
      directions: [
        {
          title: 'By Car',
          text: 'The office is on the 1st floor at Slovenska cesta 24. Free parking (up to 2 hours) is available at the central parking area behind the building.',
        },
        {
          title: 'Orientation',
          text: 'Near Špas Theater and the Municipality of Mengeš. The office entrance is on the back side of the building, through the inner parking area near Mestna kavarna Mesing.',
        },
        {
          title: 'Appointment',
          text: 'Clients are received by prior appointment. Call 040-811-830 or email tajnistvo@op-bm.si.',
        },
      ],
      photoTitle: 'Slovenska cesta 24, Mengeš',
      photoSubtitle: '1st floor · entrance at the rear side of the building',
      address: 'The law office is located on the 1st floor of a commercial and residential building at Slovenska cesta 24 in Mengš, in the immediate vicinity of Špas Theater and the Municipality of Mengš.',
      entrance: 'The entrance to the law office is located on the back side of the building, through the central internal parking lot next to Mestna kavarni Mesing.',
      parking: 'Free parking (up to two hours) for visitors is available in the parking lot (central parking lot) in front of the building.',
    },
    aboutUs: {
      title: 'About Us',
      intro: 'Meet our legal team and key information about the members of our law office.',
      noImage: 'Image coming soon',
      sectionLabel: 'About Us',
      mainTitle: 'Our Team',
      teamLabel: 'Team',
      teamTitle: 'Office Associates',
      achievementsToggle: 'Achievements and Publications',
      yearsExperienceValue: '30+',
      yearsExperienceLabel: 'years of experience',
      martinHighlights: [
        { title: 'Attorney and Mediator', text: 'Strategic legal representation and mediation.' },
        { title: 'Former Judge', text: 'Courtroom perspective from judicial experience.' },
        { title: 'Personal Approach', text: 'Thoughtful and responsible legal representation.' },
        { title: 'By Prior Appointment', text: 'Clients are received by prior arrangement.' },
      ],
      mojcaTags: ['Family Law', 'Labor Law', 'Criminal Law', 'SL / EN / HR / SR / DE'],
      thirdTags: ['Office Operations', 'Administration', 'SL / EN'],
      martin: {
        role: 'Martin Bregant, Attorney, Mediator and Director',
        paragraphs: [
          'In 2025, Martin Bregant marked 30 years of independent legal practice. He began his professional career as a judge at the Local Court in Ljubljana and later at the Local Court in Kamnik. In 1995, he concluded his judicial career and continued his professional path as an attorney.',
          'He provides his clients with thoughtful, strategic, and responsible legal representation. His approach is based on a thorough legal assessment of each case, taking into account case law, evidentiary options, and realistic procedural risks. Thanks to his many years of experience in both the judiciary and legal practice, he can assess a case from the perspective of judicial decision-making, which enables careful strategic planning.',
          'He understands that legal proceedings often represent a major turning point in a person’s life, and therefore strives to handle every matter with professional excellence and a human approach.',
          'In addition to legal practice, he also works as a mediator. Clients may engage him to conduct mediation proceedings when they wish to resolve disputes peacefully, quickly, and through an agreement that considers the interests of all parties involved. His experience from both the judiciary and legal practice allows him to lead the mediation process impartially and effectively.',
          'Clients are received by prior appointment.',
        ],
        contactTitle: 'Contact:',
        emailLabel: 'Email:',
        phoneLabel: 'Phone:',
        email: 'martin.bregant@siol.net',
        phone: '040-811-830',
      },
      mojca: {
        role: 'Mojca Musič, LL.M., Attorney Trainee and Judicial Trainee',
        paragraphs: [
          'Mojca Musič is employed at the firm as an attorney trainee while also completing judicial training at the District Court in Ljubljana.',
          'In 2024, under the mentorship of Assoc. Prof. mag. can. ius. Dr. Borut Holcman, univ. dipl. theol., moralno juridični spec., she graduated with distinction from the Faculty of Law, University of Maribor, in the field of legal profession history. She is currently a doctoral candidate in legal history, where she continues researching the role of the legal profession in judicial proceedings.',
          'In her work, she focuses primarily on family, labor, and criminal law, with particular professional and personal dedication to family law. She believes this legal field directly affects an individual\'s dignity, safety, and fundamental life circumstances. She has a strong sense of empathy.',
          'In her work, she actively uses Slovenian, English, Croatian, and Serbian, and conversationally also German.',
          'Clients are received by prior appointment.',
        ],
        contactTitle: 'Contact:',
        emailLabel: 'Email:',
        phoneLabel: 'Phone:',
        email: 'mojca.remic@op-bm.si',
        phone: '040-811-830',
        achievementsTitle: 'ACHIEVEMENTS:',
        achievements: [
          '2017 – 1st place in the literary competition of the Student Association of the Faculty of Law UM with the essay “Judgments of the Courts of the Republic of Slovenia before the European Court of Human Rights (ECtHR)” and publication of an article in the Iusto Iure journal',
          '2019 – 1st place in the mediation competition (labor law field), organized by the Faculty of Law, University of Maribor',
          '2020 - Participation in the project “ŠIPK – Measurement of Electric Motor Characteristics for Electric Vehicle Drive” at the Faculty of Energy Technology, University of Maribor, focused on verifying product compliance with national and European regulations and preparing technical documentation.',
          '2020 - Participation in the conference “What are human rights?”, organizer: United for Human Rights (UHR)',
          '2021 – Participation in the Amicus Curiae project (practice at the Administrative Court of the Republic of Slovenia and the District Court in Maribor)',
          '2026 - Project lead of the project “Constitutive Professions in the Judiciary,” implemented under the public call “Problem-based learning of students in the work environment: economy, non-economy and non-profit sector in the local/regional environment 2024-2027 (PUŠ in the work environment 2024-2027) - 2nd opening.”',
        ],
        bibliographyTitle: 'PERSONAL BIBLIOGRAPHY:',
        bibliography: [
          'REMIC, Mojca. Ali delavec lahko odkloni službeno pot, ker ne želi opraviti obveznega cepljenja?. Pravna praksa: PP. [Print ed.]. 29 Aug 2024, vol. 42, no. 30/31, pp. 20-21, author photo. ISSN 0352-0730. [COBISS.SI-ID 205701891]',
          'REMIC, Mojca. "Beschirmern vor vnrecht" - vloga odvetnika v procesu skozi zgodovino: master thesis. Maribor: [M. Remic], 2024. 1 online resource (1 PDF file, 76 pp.). Digital Library of the University of Maribor – DKUM. [COBISS.SI-ID 199769859]',
          'REMIC, Mojca. Pot k digitalizaciji pravosodja v EU: uredba (EU) 2020/1784 o vročanju sodnih in izvednsodnih pisanj v civilnih ali gospodarskih zadevah. Pravna praksa: PP. [Print ed.]. 10 Oct 2024, vol. 43, no. 37/38, pp. 7-8, author photo. ISSN 0352-0730. [COBISS.SI-ID 211008771]',
          'REMIC, Mojca. Pogodba o dosmrtnem preživljanju med zakoncema. Pravna praksa: PP. [Print ed.]. 6 Mar 2025, vol. 44, no. 9, pp. 9-10, author photo. ISSN 0352-0730. [COBISS.SI-ID 228136707]',
        ],
      },
      third: {
        role: 'Maša Rožman, Bachelor of Laws, Office Manager',
        paragraphs: [
          'Maša Rožman is employed as the law office manager.',
          'She performs her work professionally, responsibly, and with a strong sense for clients\' needs. As office manager, she handles all organizational and administrative tasks and ensures that office operations run smoothly and without interruption.',
          'In 2023, she graduated with distinction from the Faculty of Law, University of Maribor, where she is currently completing her master\'s studies.',
          'She is distinguished by precision, strategic thinking, and a personal approach through which she builds long-term, trust-based relationships.',
          'In her work, she actively uses Slovenian and English.',
        ],
        contactTitle: 'Contact:',
        emailLabel: 'Email:',
        phoneLabel: 'Phone:',
        email: 'tajnistvo@op-bm.si',
        phone: '040-811-830',
      },
    },
    contact: {
      title: 'Contact',
      intro: 'Contact us for legal advice: ',
      email: 'info@novak-partners.com',
      phone: '+386 1 234 5678',
      workingHours: {
        title: 'Working Hours',
        hours: 'Our office is open Monday to Friday from 8:00 AM to 4:00 PM, except on Fridays until 13:00 PM.',
        reservation: 'A meeting at the office requires prior appointment reservation by phone or through the contact form below.',
        response: 'We will respond to your questions as soon as possible.',
        documents: 'Please bring all available documentation regarding your matter to your appointment. After the meeting, we will present you with an estimated cost for your case, and if you decide to retain our services, you will sign a power of attorney on the basis of which we can begin work immediately.',
      },
      form: {
        name: 'Name and Surname',
        namePlaceholder: 'Your name and surname',
        email: 'Email',
        emailPlaceholder: 'your@email.example',
        subject: 'Subject',
        subjectPlaceholder: 'Brief summary of your inquiry',
        message: 'Message',
        messagePlaceholder: 'Details of your question',
        submit: 'Send',
      },
      status: {
        required: 'Please fill in all fields.',
        invalidEmail: 'Please enter a valid email address.',
        sending: 'Sending message ...',
        success: 'Your message was sent successfully.',
        error: 'Sending failed. Please try again.',
        botDetected: 'Sending failed.',
      },
    },
    practiceAreas: {
      title: 'Areas of Practice',
      intro: 'Our law firm covers a wide spectrum of legal fields.',
      areas: [
        {
          title: 'COMMERCIAL AND CONTRACTUAL LAW AND BUSINESS RELATIONS',
          points: [
            'Advice on issues related to domestic and international business relations',
            'Drafting and reviewing commercial contracts',
            'Participation in negotiations',
            'Representation in court proceedings arising from contracts and business relations',
            'Preparation of due diligence reviews',
          ]
        },
        {
          title: 'COMMERCIAL DISPUTES AND DEBT COLLECTION',
          points: [
            'Representation in all commercial disputes and mediation',
            'Advice on creditor-debtor relations',
            'Representation in enforcement proceedings',
          ]
        },
        {
          title: 'BANKRUPTCY AND INSOLVENCY LAW',
          points: [
            'Advice in bankruptcy, compulsory settlement and liquidation proceedings',
            'Filing of claims, separation rights and creditors\' rights',
            'Representation in other proceedings related to bankruptcy and compulsory settlement proceedings',
          ]
        },
        {
          title: 'COMMERCIAL CRIMINAL LAW',
          points: [
            'Drafting of criminal charges',
            'Drafting and filing of private lawsuits',
            'Drafting of property damage claims of injured parties',
          ]
        },
        {
          title: 'REAL ESTATE LAW',
          points: [
            'Advice, drafting or review of all types of contracts related to real estate',
            'Participation in establishing easements and other rights',
            'Representation in disputes concerning real estate and rights related to real estate and rental agreements',
            'Representation in possession disputes and non-contentious proceedings for boundary adjustment, division of joint ownership, and determination of public paths',
            'Advice on arrangement of residential and rental relations',
            'Preparation of notarial acts',
            'Proposal for registration in the land registry',
          ]
        },
        {
          title: 'LAW OF OBLIGATIONS',
          points: [
            'Advice and representation in damages disputes',
            'Drafting of contracts under law of obligations',
            'Advice and representation in disputes under law of obligations',
          ]
        },
        {
          title: 'SUCCESSION LAW',
          points: [
            'Advice and representation on succession matters, estate proceedings and succession disputes',
            'Drafting of wills',
            'Drafting of transfer contracts, usufruct contracts and contracts for lifetime care',
          ]
        },
        {
          title: 'FAMILY LAW',
          points: [
            'Advice on legal issues regarding dissolution of marriage and separation of unmarried partners, division of property and determination of maintenance',
            'Representation in divorce proceedings and property division proceedings',
          ]
        },
        {
          title: 'LABOR LAW',
          points: [
            'Advice on labor law matters',
            'Preparation of internal general labor agreements of the employer',
            'Advice and representation in termination proceedings',
            'Representation in other labor law disputes',
            'Participation in disciplinary proceedings',
          ]
        },
        {
          title: 'ADMINISTRATIVE PROCEDURES AND ADMINISTRATIVE DISPUTES',
          points: [
            'Advice and participation in inspection procedures',
            'Drafting and filing of lawsuits in administrative disputes',
          ]
        },
      ]
    },
    documents: {
      title: 'Terms and Conditions',
      intro: 'Attorney Martin Bregant (hereinafter: the Attorney) is a member of the Slovenian Bar Association and is entitled to charge legal services in accordance with the currently applicable Attorney Tariff of the Slovenian Bar Association (hereinafter: the Tariff), unless a different written agreement has been concluded with the client.',
      sections: [
        {
          title: 'Formation of the Mandate Relationship',
          paragraphs: [
            'The Attorney is not obliged to accept every offered power of attorney. The mandate relationship is established when the Attorney expressly confirms acceptance of the power of attorney or otherwise confirms in writing to the client that representation has been accepted or legal services have commenced.',
            'In case of doubt, the mandate is deemed accepted on the date of written confirmation or on the date the Attorney actually begins to perform the requested services with the client\'s knowledge and consent.',
          ],
        },
        {
          title: 'Method of Charging Services',
          paragraphs: [],
        },
        {
          title: '1. Application of the Attorney Tariff',
          paragraphs: [
            'If no special agreement on a different charging method is concluded between the Attorney and the client, services are charged in accordance with the provisions of the Tariff.',
          ],
        },
        {
          title: '2. Agreement on Different Payment Terms',
          paragraphs: [
            'The Attorney and the client may, in accordance with applicable regulations, conclude a written agreement on a different method of payment (hereinafter: special agreement).',
            'If the Attorney proposes an hourly rate and the client agrees (expressly or implicitly by allowing work to begin without objection), a special agreement on hourly billing is deemed concluded. The hourly rate is always confirmed to the client in writing (e.g., by email). These terms and conditions form an integral part of such agreement unless expressly agreed otherwise.',
            'If a flat fee is agreed, services exceeding the agreed scope are charged at the agreed hourly rate or - if such rate is not specified - according to the Tariff.',
            'If a specific service is not covered by the special agreement, the Tariff applies to that service.',
          ],
        },
        {
          title: 'Hourly Rate and Costs',
          paragraphs: [
            'The Attorney may prepare an informational price list annually, taking into account inflation, complexity of services, and other relevant circumstances.',
            'Depending on the nature and complexity of a matter, the Attorney may propose a standard or higher hourly rate. The final amount is subject to agreement with the client.',
            'The minimum billing unit for hourly billing is 30 minutes.',
            'In addition to fees, the Attorney reserves the right to charge material costs in the amount of 3% of the value of services, unless agreed otherwise.',
            'Unless specified otherwise, postal shipments are charged on a flat basis, or by actual costs where those differ from the amounts below:',
          ],
          bullets: [
            'EUR 5 for registered mail within Slovenia',
            'EUR 10 for shipments within the EU',
            'EUR 20 for shipments outside the EU',
          ],
        },
        {
          title: 'Issuing Invoices and Payment Terms',
          paragraphs: [
            'Unless agreed otherwise, the Attorney issues invoices monthly for work performed in the previous period or upon completion of an individual logically completed phase of proceedings.',
            'The payment deadline is 8 days from the invoice issue date, unless agreed otherwise.',
            'In case of delay, the client is obliged to pay statutory default interest and any collection costs.',
            'If the Attorney becomes liable for VAT, VAT will be charged on all services in accordance with applicable legislation.',
            'At the Attorney\'s sole discretion, the charged fee may be reduced, but it may not be unilaterally increased beyond the agreed terms.',
            'The Attorney is entitled to settle due claims for legal services from amounts received on behalf of the client, issue an appropriate invoice indicating such payment, and transfer the remaining balance to the client.',
          ],
        },
        {
          title: 'Notice Regarding Recovery of Costs in Proceedings',
          paragraphs: [
            'Courts and other authorities generally recognize and award representation costs according to the Tariff, regardless of any different agreement between the Attorney and the client.',
          ],
        },
        {
          title: 'Revocation of Power of Attorney',
          paragraphs: [
            'If the client revokes the power of attorney without justified reason before the matter is concluded, the client must pay for services already performed and costs incurred up to the date of revocation, unless expressly agreed otherwise.',
            'For any disputes, the court territorially competent at the Attorney\'s registered office shall have jurisdiction.',
          ],
        },
        {
          title: 'Confidentiality and Personal Data Protection',
          paragraphs: [
            'All information and documents exchanged between the Attorney and the client are treated as confidential.',
            'For the purpose of checking a potential conflict of interest, the Attorney may disclose the existence of the mandate relationship and the general nature of the matter, but not the content of confidential data.',
            'In providing services, personal data may be processed in accordance with applicable European and national legislation. The Attorney uses personal data solely for the purpose of providing legal services, protects it as confidential, and ensures appropriate security measures.',
            'After termination of the mandate relationship, personal data is returned or destroyed where legally permissible and in accordance with applicable law.',
          ],
        },
        {
          title: 'Limitation of Liability',
          paragraphs: [
            'The Attorney\'s liability for damages is limited to the amount of fees paid for services performed within 30 days prior to the event from which potential liability arises.',
            'The Attorney is not liable for indirect damage, loss of profit, loss of revenue, or other consequential damages.',
            'The Attorney holds mandatory professional liability insurance with Wiener Städtische under the insurance scheme of the Slovenian Bar Association.',
          ],
        },
      ],
    },
    freeLegalAid: {
      title: 'Free Legal Aid',
      paragraphs: [
        'At our law office, we also provide representation of clients within the framework of free legal aid (BPP).',
        'Free legal aid ensures access to judicial protection for persons who could not exercise this right without harming their own livelihood and the livelihood of their family. For eligible applicants who meet financial and substantive requirements, it primarily provides access to judicial protection and, exceptionally, pre-trial legal advice and settlement arrangements.',
        'Before the attorney begins work, a decision granting free legal aid and a referral for free legal aid are required, both issued by the court\'s professional service for free legal aid.',
        'We also assist clients in completing and preparing the application for free legal aid (BPP), including review of required documentation and advice regarding compliance with financial eligibility criteria.',
      ],
      linksTitle: 'The application can be submitted electronically via the e-Uprava portal or in writing at the competent court:',
      links: [
        {
          label: 'https://e-uprava.gov.si/podrocja/vloge/vloga.html?id=1225',
          url: 'https://e-uprava.gov.si/podrocja/vloge/vloga.html?id=1225',
        },
        {
          label: 'https://e-uprava.gov.si/si/podrocja/drzava-druzba/pravna-pomoc/brezplacna-pravna-pomoc',
          url: 'https://e-uprava.gov.si/si/podrocja/drzava-druzba/pravna-pomoc/brezplacna-pravna-pomoc',
        },
      ],
    },
    mediation: {
      title: 'Mediation',
      paragraphs: [
        'At our law office, we devote significant attention to alternative dispute resolution so that clients can avoid court proceedings.',
        'Mediation is a confidential and structured process of amicable dispute resolution in which a neutral third person - a mediator - helps the parties reach a mutually agreed solution. Its key advantage is that the parties themselves shape a solution that reflects their interests, needs, and future relationship, instead of having the dispute decided by a court.',
        'Attorney Martin Bregant is also an experienced and effective mediator who can be engaged to resolve both judicial and out-of-court disputes. As a mediator, he acts impartially and facilitates a balanced, constructive dialogue between the parties.',
        'The mediation process is generally faster and more cost-effective than court proceedings, while also offering greater flexibility and confidentiality. The resulting agreement may serve as the basis for a court settlement or an enforceable agreement, if the parties so decide.',
        'If you are considering mediation as a way to resolve a dispute, we will gladly advise you on the suitability of the procedure and the options for its implementation.',
      ],
      bulletsTitle: 'Mediation is particularly appropriate:',
      bullets: [
        'when parties wish to preserve a proper or long-term relationship (e.g., in family, partner, or business relationships)',
        'when a fast and discreet dispute resolution is important',
        'when parties want to actively participate in shaping the agreement',
        'when a settlement is possible but communication between the parties is difficult',
      ],
      contactTitle: 'Contact',
      emailLabel: 'Email:',
      email: 'tajnistvo@op-bm.si',
      phoneLabel: 'Phone:',
      phone: '040-811-830',
      linksTitle: 'More about the mediation process:',
      links: [
        {
          label: 'https://www.odv-zb.si/mediacijski-center/pogosta-vprasanja-in-odgovori/#htoc-v-katerih-primerih-je-mediacija-smiselna',
          url: 'https://www.odv-zb.si/mediacijski-center/pogosta-vprasanja-in-odgovori/#htoc-v-katerih-primerih-je-mediacija-smiselna',
        },
        {
          label: 'https://nasodiscu.si/mediacija',
          url: 'https://nasodiscu.si/mediacija',
        },
      ],
    },
    privacy: {
      title: "Privacy Policy",
      intro: "This policy explains what personal data we process through this website, for what purpose and on what legal basis, who we share it with, and what rights you have in relation to it.",
      updated: "Last updated: 14 October 2026",
      sections: [
        {
          title: "1. Data controller",
          paragraphs: [
            "The controller of personal data processed through this website is Odvetniška pisarna Martina Breganta (Law Office of Martin Bregant), Slovenska cesta 24, 1234 Mengeš, Slovenia.",
            "Company registration number: 2511975000. Tax number: 10045503.",
            "For data protection matters you can reach us at tajnistvo@op-bm.si or on 040 811 830.",
          ],
        },
        {
          title: "2. What personal data we process",
          paragraphs: [
            "The website requires no registration and creates no user accounts. We process personal data only when you provide it yourself:",
          ],
          bullets: [
            "Contact form: name, email address, subject and message content.",
            "Direct contact: the data you provide if you call us or write to the address published on this site.",
            "Technical data: visiting the site opens connections to the external services described in section 5, which receive your IP address.",
          ],
          extra: [
            "The website contains no analytics, visitor counters, advertising trackers or profiling. We do not make automated decisions based on your data.",
          ],
        },
        {
          title: "3. Purpose and legal basis",
          bullets: [
            "Answering your enquiry and, where applicable, entering into a client relationship — the legal basis is taking steps at your request prior to entering into a contract (Article 6(1)(b) GDPR).",
            "Operating and securing the website and protecting it from abuse — the legal basis is our legitimate interest (Article 6(1)(f) GDPR).",
            "Meeting the statutory obligations that apply to the legal profession — the legal basis is legal obligation (Article 6(1)(c) GDPR).",
          ],
          paragraphs: [
            "Providing data through the contact form is neither a statutory nor a contractual requirement. If you do not provide it, we simply cannot reply to your message.",
          ],
        },
        {
          title: "4. Contact form",
          paragraphs: [
            "When you submit the contact form, the data you entered is sent from your browser through a service for delivering email from web forms (EmailJS), which delivers it to the firm's mailbox. The provider of that service acts as a data processor to that extent.",
            "The form includes a hidden anti-spam field that visitors do not fill in; a completed field indicates automated submission and the message is not sent. No personal data is processed in that field.",
            "Your message reaches the firm's mailbox and is treated confidentially, in accordance with the duty of attorney-client confidentiality.",
            "Please do not send special categories of personal data or details of your case through the contact form. For that, please arrange a meeting or a telephone conversation.",
          ],
        },
        {
          title: "5. External services embedded in the website",
          paragraphs: [
            "The website uses two Google services that load directly from Google's servers. In doing so, your IP address and basic browser information are disclosed to Google — before you click on anything. We have no influence over the scope of that processing.",
          ],
          bullets: [
            "Google Fonts: typefaces load from fonts.googleapis.com and fonts.gstatic.com. This happens on every page.",
            "Google Maps: the \"Where We Are\" page embeds a map showing the firm's location. Opening that page establishes a connection to Google's servers, which may set cookies in your browser.",
          ],
          extra: [
            "Google's privacy policy is available at https://policies.google.com/privacy. If you prefer not to establish these connections, you can use a browser or extension that blocks requests to Google domains; the site will still work, simply with a system typeface and without the map.",
          ],
        },
        {
          title: "6. Cookies and local storage",
          paragraphs: [
            "This website does not set cookies of its own and uses no cookies for analytics or advertising.",
            "A single item is stored in your browser's local storage — the interface language you selected (Slovenian, German or English) — so that you do not have to choose it again on your next visit. That item stays in your browser, is never sent to a server, and does not allow you to be identified. You can remove it at any time by clearing your browser data.",
            "Cookies may be set by Google when the embedded map is displayed, as described in section 5.",
          ],
        },
        {
          title: "7. Retention",
          paragraphs: [
            "We keep messages received through the contact form for 12 months from the last communication, after which we delete them.",
            "If your enquiry leads to a client relationship, the data is kept as part of the case file in line with the periods set by legislation and professional rules.",
          ],
        },
        {
          title: "8. Recipients and transfers outside the EEA",
          paragraphs: [
            "We do not sell personal data and do not pass it to third parties for their own purposes.",
          ],
          bullets: [
            "The provider of the web form email delivery service (processor).",
            "The email provider whose mailbox receives your message (processor).",
            "The website hosting provider: Netlify (Netlify, Inc., USA).",
            "Google — to the extent described in section 5.",
            "Competent authorities, where required by law.",
          ],
          extra: [
            "Some of these providers may process data outside the European Economic Area. In such cases the transfer takes place on the basis of the mechanisms provided for in the General Data Protection Regulation — standard contractual clauses or an adequacy decision of the European Commission.",
          ],
        },
        {
          title: "9. Your rights",
          paragraphs: [
            "In relation to your personal data you have the right:",
          ],
          bullets: [
            "to access the data we process about you;",
            "to have inaccurate data corrected and incomplete data completed;",
            "to erasure, where there is no longer a basis for processing;",
            "to restriction of processing;",
            "to portability of the data you provided to us;",
            "to object to processing based on our legitimate interest;",
            "to withdraw consent where processing is based on it, without affecting the lawfulness of processing before withdrawal.",
          ],
          extra: [
            "To exercise a right, write to tajnistvo@op-bm.si. We will respond within one month of receiving your request at the latest.",
            "If you believe the processing of your data breaches the applicable rules, you have the right to lodge a complaint with the supervisory authority — the Information Commissioner of the Republic of Slovenia (Informacijski pooblaščenec).",
            "Please note that access to data covered by attorney-client confidentiality may be restricted under the rules governing the legal profession.",
          ],
        },
        {
          title: "10. Security",
          paragraphs: [
            "The website is served over an encrypted HTTPS connection. Access to received email is limited to the people in the firm who need to handle the matter and is subject to attorney-client confidentiality.",
            "No transmission over the internet is completely secure, so for sensitive information we recommend speaking with us in person.",
          ],
        },
        {
          title: "11. Changes to this policy",
          paragraphs: [
            "We may change this policy when the website's functionality or the applicable rules change. The version published on this page is the one in force; the date of the last change is shown at the top.",
          ],
        },
      ],
    },
    footer: {
      privacy: "Privacy Policy",
      contact: 'Contact',
      location: 'Where we are',
      accounts: 'Transaction Account',
      credit: '© %year% BM Lawyers',
    },
  },
};
